/* eslint-disable react-hooks/exhaustive-deps */
import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import {
    checkDisplayBtnAddView,
    getCurrentDrilldownData,
    getInitDataOrganizationProject,
    getUseRoleInProject,
    getVisibleWidth,
    handleClickCreateTicketType,
    hasKnowledgeChatPermission,
    isDisplayEyeSlashIcon,
    onKeyPressSearchKeyWord,
    onSelectSugguestOption,
    onSubmitSearchListKnowledge,
    openDrilldownAndDetailSearch,
    permissionChangeShareRangeStatus,
    removeDrillDownSelectedSearchTimeAgo,
    removeDrillDownSelectedSearchTimeRange,
    autoReloadTicket,
    getListTicketKnowledge,
    hasKnowledgeChatPermissionInChatThread,
    isCheckMethodSimilar,
    isViewAllKnowledgeInCorporation,
    displayTagOfThumbAttach,
    handleSelectFilePdf,
    isDisplayIconSearchFileAndPageKnowledge,
    getPreviousViewStructureDefault,
    getListTagFieldOfForm,
    isShowFormEditRangeMulti,
    getDataPublicRange,
    getAllBookmarkUserCanUse
} from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import {
    generateDetatilTicketTitle,
    viewTicketKnowledgeDetail
} from '@/component/ticketList/handler/TicketHandler';
import { getTitle } from '@/component/ticketList/handler/TicketListHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import {
    multiPanelAtom,
    panelSettingAtom,
    reloadListTicketKnowleadPanel,
    knowledgeViewSelectedAtom,
    listenOnChangeKnowledgeViewSelectedAtom,
    isUsingChatAIAtom
} from '@/state/atom/panelAtom';
import { projectInuseDetailAtom, projectListInCorporationByUserIdAtom, viewKnowledgeProjectSelectedAtom } from '@/state/atom/projectAtom';
import {
    helpdeskTicketLastUserActionAtom,
    knowledgeSearchTagSuggestAtom,
    listOptionViewVisibilityForKnowledgeAtom,
    visibilityForKnowledgeAtom,
    isShowVisibilityKnowledgeAtom,
    publicKnowledgeHitNumberTicketAtom,
    drilldownDataSelectedForLog
} from '@/state/atom/ticketAtom';
import {
    helpdeskDefaultDrillDownDataAtom,
    helpdeskDefaultSelectedOptionAtom,
    helpdeskDrillDownDataAtom,
    helpdeskViewStructureAtom,
    isLoadingHelpdeskDrillDownDataAtom,
    isLoadingProjectInuseDrillDownDataAtom,
    masterKnowledgeHyperLinkAtom,
    projectInuseDefaultDrillDownDataAtom,
    projectInuseDefaultSelectedOptionAtom,
    projectInuseDrillDownDataAtom,
    projectInuseViewStructureAtom,
    knowledTicketNotIncludeAtom,
    knowledgeTicketContainAnyAtom,
    optionsSortAtom,
    destinationPrjIdAtom,
} from '@/state/atom/ticketKnowledgeAtom';
import { userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import {
    setPanelSelector,
    triggerReloadTab,
    triggerReloadTicketListByPanelType,
    updatePanelAfterCreateTicketSelector,
} from '@/state/selector/panelSelector';
import { Badge, Button, Checkbox, Collapse, FormControl, FormControlLabel, FormGroup, IconButton, List, ListItem, ListItemText, MenuItem, Paper, Popover, Popper, Radio, RadioGroup, Select, TextField, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { I18n } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from '../common/FileUploaded';
import LoadingPanel from '../common/LoadingPanel';
import { permissionCreateTicketKnowledge } from '../common/layout/addTicket/handler/AddTicketHandler';
import {
    getDrilldownItemDataSelected,
    removeDrillDownSelected,
} from '../ticketList/handler/KnowledgeTicketHandler';
import AlertDialog from '../ticketList/knowledge/AlertDialog';
import './ListTicketKnowledge.css';
import { onHoverPopoverFootprint } from './handler/FootprintHandler';
import {
    handleClickChecked,
    handleClickShareStatus,
    handleClosePopover,
    isAddtionalViewOrEdit,
    isCheckedChangeStatusOption
} from './handler/ShareStatusKnowledgeHandler';
import {
    createNewView,
    getListViews,
    getViewDefaultsChatAI,
    isViewWasChanged,
    onChangeViewSelected,
    onChangeVisibilitySetting,
    onHandlerShowView,
} from './handler/ViewHandler';
import { DialogNoticeViewChanged } from './views/DialogNoticeViewChanged';
import { DialogViewNameError } from './views/DialogViewNameError';
import DraggableViewsList from './views/DraggableViewsList';
import SeemoreViewKnowledgeList from './views/SeemoreViewKnowledgeList';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import {
    handleChangeSearchAttribute,
    handleChangeSearchMethod,
    handleChangeSearchPdfOption,
    handleOnChangeSearchSynonym,
    isDisplayOptionSearchSynonymForKnowledgeList
} from './handler/DrilldownAndDetailSearchHandler';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { getTicketById } from '@/service/ticketService';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { getFirstProjectWhenOpenChatAI, getVisibilityDefault, isDisplayIconChatAIOnKnowledgeList } from '../common/layout/gNav/handler/MenuHandler';
import { createNewAIChatThread } from '@/service/chatAIService';
import { v4 as uuidv4 } from 'uuid';
import { getPublicAPI } from '@/service/publicService';
import BulkAction from './elements/BulkAction';
import RenderMultiPublicRange from './elements/RenderMultiPublicRange';
import RenderTagFieldInForm from './elements/RenderTagFieldInForm';
import RenderExportMenu from './elements/RenderExportMenu';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import Bookmark from './elements/Bookmark/Bookmark';
import TaggedBookmarkListName from './elements/Bookmark/TaggedBookmarkListName';
import { getCategoryListOfProject } from '@/component/project/handler/SettingChatbotHandler.js';
import { signOut } from '@/service/authenService';
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';
import { normalizeString } from './handler/ListTicketKnowledgeHandler';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        // marginRight: '15px',
        border: 'none',
        boxShadow: 'unset',
        borderRadius: '0px',
        '& .MuiTextField-root': {
            margin: '0',
            width: '100%'
        }
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        width: '100%'
    },
    iconButton: {
        padding: 10
    },
    divider: {
        height: '100%',
        margin: 4
    },
    arrowIcon: {
        fill: 'white'
    }
}));

const listOptionViewVisibilityInitData = [
    {
        value: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
        label: 'プライベート'
    },
    {
        value: Constant.VISIBILITY_SETTING_TYPE.PROJECT,
        label: 'プロジェクトメンバー'
    },
    {
        value: Constant.VISIBILITY_SETTING_TYPE.IN_ORG,
        label: '組織内'
    },
    {
        value: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
        label: '一般公開'
    }
];

const OverflowTooltip = props => {
    // Create Ref
    const textElementRef = useRef();

    const compareSize = () => {
        const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
        setHover(compare);
    };

    // compare once and add resize listener on "componentDidMount"
    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
    }, []);

    // remove resize listener again on "componentWillUnmount"
    useEffect(
        () => () => {
            window.removeEventListener('resize', compareSize);
        },
        []
    );

    // Define state and function to update the value
    const [hoverStatus, setHover] = useState(false);
    return (
        <Tooltip
            title={props.value}
            disableHoverListener={!hoverStatus}
            style={{ fontSize: '2em' }}
        >
            <div
                ref={textElementRef}
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
                className="knowledge-outline"
            >
                {props.value}
            </div>
        </Tooltip>
    );
};
OverflowTooltip.defaultProps = {
    value: ''
};

export default function ListTicketKnowledge(props) {
    props = {...props, API: API}
    const masterKnowledgeHyperLink = useRecoilValue(masterKnowledgeHyperLinkAtom);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);

    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const projectList = useRecoilValue(projectListInCorporationByUserIdAtom);

    // const updatePanelDrilldown = useSetRecoilState(updatePanelDrilldownAfterSwitchDeskProject);

    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    // reload panel
    const [isCustomer, setIsCustomer] = useState(props.isCustomer);
    const [customerId, setCustomerId] = useState(props.customerId);
    const [ticketIdList, setTicketIdList] = useState(props.ticketIdList);
    const [masterKnowledgeHyperLinkStatus, setMasterKnowledgeHyperLinkStatus] = useState(props.masterKnowledgeHyperLink);
    const [visibilitySettingType, setVisibilitySettingType] = useState(props.visibilitySettingType);

    // Add new panel
    let addNewPanel = useSetRecoilState(setPanelSelector);

    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingView, setIsLoadingView] = useState(false);

    const [isLoadDrillDown, setIsLoadDrillDown] = useState(false);

    // ticket knowledge list
    const [ticketKnowledgeList, setTicketKnowledgeList] = useState([]);

    const [addViewPopover, setAddViewPopover] = useState(null);
    const isOpenFormTypePopover = Boolean(addViewPopover);
    const id = isOpenFormTypePopover ? 'simple-popover' : undefined;
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [createTicketTypePopover, setCreateTicketTypePopover] = useState(null);
    const [viewSelected, setViewSelected] = useState({});
    const [listView, setListView] = useState([]);

    const [openListViewHide, setOpenListViewHide] = useState(false);
    const [organizationSelected, setOrganizationSelected] = useState({});
    const [projectSelected, setProjectSelected] = useState({});

    const [projectSelectedId, setProjectSelectedId] = useState(props.projectSelectedId ? props.projectSelectedId : projectInuseDetail.id);
    const [viewKnowledgeProjectSelected, setViewKnowledgeProjectSelected] = useRecoilState(viewKnowledgeProjectSelectedAtom);

    
    const [corporationSelectedId, setCorporationSelectedId] = useState(props.corporationSelectedId ? props.corporationSelectedId : corporationDetail.id);
    
    const [organizationProject, setOrganizationProject] = useState({});
    
    // const [visibilitySetting, setVisibilitySetting] = useState('');
    const setVisibilitySettingListOption = useSetRecoilState(
        listOptionViewVisibilityForKnowledgeAtom
    );
    const [userRoleInProject, setUserRoleInProject] = useState('');

    const [viewStructure, setViewStructure] = useRecoilState(
        isCustomer ? helpdeskViewStructureAtom : projectInuseViewStructureAtom
    );

    const [drilldownDataSelected, setDrillDownDataSelected] = useState([]);
    const [drilldownDataForLog, setDrillDownDataForLog] = useRecoilState(
        drilldownDataSelectedForLog
    );
    
    // option-search state
    const [keywordSearch, setKeywordSearch] = useState(viewStructure.keyword);
    const [triggerSearch, setTriggerSearch] = useState('');
    const [optionSearchTimeRange, setOptionSearchTimeRange] = useState('');
    const [optionSearchTimeAgo, setOptionSearchTimeAgo] = useState('');
    const [destinationPrjId, setDestinationPrjId] = useRecoilState(destinationPrjIdAtom);

    const setDefaultSelectedOption = useSetRecoilState(
        isCustomer ? helpdeskDefaultSelectedOptionAtom : projectInuseDefaultSelectedOptionAtom
    );


    const [isOpenDialogViewNameError, setIsOpenDialogViewNameError] = useState(false);
    const [isOpenDialogViewChanged, setIsOpenDialogViewChanged] = useState(false);
    const [viewNameErrorType, setViewNameErrorType] = useState('');
    const inputViewNameRef = useRef();
    const inputKeyWordRef = useRef();

    // DrillDown data
    const setIsLoadingDrillDown = useSetRecoilState(
        isCustomer ? isLoadingHelpdeskDrillDownDataAtom : isLoadingProjectInuseDrillDownDataAtom
    );
    const [drillDownData, setDrillDownData] = useRecoilState(
        isCustomer ? helpdeskDrillDownDataAtom : projectInuseDrillDownDataAtom
    );
    const [sugguestionList, setSugguestionList] = useState([]);
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    const [defaultDrillDownData, setDefaultDrillDownData] = useRecoilState(
        isCustomer ? helpdeskDefaultDrillDownDataAtom : projectInuseDefaultDrillDownDataAtom
    );

    const [visibilityKnowledgeAtom, setVisibilityKnowledgeAtom] = useRecoilState(
        visibilityForKnowledgeAtom
    );
    const setIsShowVisibilityKnowledgeAtom = useSetRecoilState(isShowVisibilityKnowledgeAtom);

    // footprint opover
    const [footPrintPopover, setFootPrintPopover] = useState(null);
    const openPopoverFootPrint = Boolean(footPrintPopover);
    const idPopOverFootPrint = openPopoverFootPrint ? 'simple-popover' : undefined;
    const [userFootprintList, setUserFootprintList] = useState([]);

    //share status
    const [shareStatusPopover, setShareStatusPopover] = useState(null);
    const [openShareStatusPopover, setOpenShareStatusPopover] = useState('');
    const idPopoverShareStatus = openShareStatusPopover ? 'simple-popover' : undefined;
    const [shareStatusData, setShareStatusData] = useState([]);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const reloadTabItemInPanel = useSetRecoilState(triggerReloadTab);
    const { enqueueSnackbar } = useSnackbar();
    const [isOpenAlertDialog, setIsOpenAlertDialog] = useState(false);
    const [triggerInterval, setTriggerInterval] = useState('');
    const nodeListView = document.querySelectorAll('.item-knowledge');
    const element = document.querySelector('#container-knowledge');

    const [pagination, setPagination] = useState({ from: 0, size: 20, lastTotal: 0 });
    const [reloadPanelId, setReloadPanelId] = useRecoilState(reloadListTicketKnowleadPanel);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [contentModalReloadPage, setContentModalReloadPage] = useState(I18n.get('COMMSG030'));
    const [totalTickets, setTotalTickets] = useRecoilState(publicKnowledgeHitNumberTicketAtom);

    const [removedTagItem, setRemovedTagItem] = useState({});
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom)
    const [searchTagSuggestKnowledge, setSearchTagSuggestKnowledge] = useRecoilState(knowledgeSearchTagSuggestAtom)
    
    const searchContentType = LogKibanaConstant.CONTENT_TYPES_TICKET.KNOWLEDGE;
    const searchContainAnyKnowledge = useRecoilValue(knowledgeTicketContainAnyAtom);
    const searchNotIncludeKnowledge = useRecoilValue(knowledTicketNotIncludeAtom);
    const isKnowledge = true;
    const [optionsSort, setOptionsSort] = useRecoilState(optionsSortAtom);

    const [isDisplayIconChatAI, setIsDisplayIconChatAI] = useRecoilState(isUsingChatAIAtom);

    const setAtomKnowledgeViewSelected = useSetRecoilState(knowledgeViewSelectedAtom);
    const [listenOnChangeKnowledgeViewSelected, setListenOnChangeKnowledgeViewSelected] = useRecoilState(listenOnChangeKnowledgeViewSelectedAtom);
    
    const [isIsnitData, setIsInitData] = useState(false);

    const [isConvertPdf , setIsConvertPdf] = useState(false);

    const [knowledgeInfoChatAi, setKnowledgeInfoChatAi] = useState(props?.knowledgeInfoChatAi ? props?.knowledgeInfoChatAi : null);
    const [isScrollNewViews, setIsScrollNewViews] = useState(false);
    const [fileNamePdfSelect, setFileNamePdfSelect] = useState('');
    const [isIncludeAttachPdf, setIsIncludeAttachPdf] = useState();
    const [previousViewStructure, setPreviousViewStructure] = useState(getPreviousViewStructureDefault(knowledgeInfoChatAi, viewStructure));
    const [isSearchSynonym,setIsSearchSynonym] = useState();
    const [isDisableSimilarSearch,setIsDisableSimilarSearch] = useState(false);
    const [isDisableSynonymSearch,setIsDisableSynonymSearch] = useState(false);
    const [isDisableIncludeAttachPdf, setIsDisableIncludeAttachPdf] = useState(false);

    // bulk-action state
    const [currentSearchParams, setCurrentSearchParams] = useState({});
    // const [isHasEditPermissionEveryTicket, setIsHasEditPermissionEveryTicket] = useState(false);
    const [isHasEditPermissionSomeTicket, setIsHasEditPermissionSomeTicket] = useState(false);
    const [isShowEditRangeMulti, setIsShowEditRangeMulti] = useState(false);
    const [isShowExportMenu, setIsShowExportMenu] = useState(false);

    const [listAdditionalAllRole, setListAdditionalAllRole] = useState([]);
    const [listDataPublicRange, setListDataPublicRange] = useState({});

    const [isShowEditTagFields,setIsShowEditTagField] = useState(false);
    const [listTagFieldOfForm,setListTagFieldOfForm] = useState([]);    
    const [selectedFormId, setSelectedFormId] = useState('')
    const [isLoadDataForPublicRangeDone, setIsLoadDataForPublicRangeDone] = useState(false);
    const [isShowDialogNotiLimit, setIsShowDialogNotiLimit] = useState(false);
    const [isShowDialogReload,setIsShowDialogReload] = useState(false)
    const [msgInProcessingIcon, setMsgInProcessingIcon] = useState("");
    const [loadingBulkItemListTagField,setLoadingBulkItemListTagField] = useState(false);
    const [limitNotiMessage, setLimitNotiMessage] = useState('');
    const [selectedFilterForm,setSelectedFilterForm] = useState({})
    const [isOpenDialogConfirm, setIsOpenDialogConfirm] = useState({
        status: false,
        action: '',
        params: {}
    });
    
    const [isViewDelete, setIsViewDelete] = useState(false)
    const [chatbotCategories, setChatbotCategories] = useState([])
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const [clickTimeout, setClickTimeout] = useState(null);

    useEffect(() => {
        const fields = viewStructure.fields;
        const isSelectForm = fields?.find(field => {
           return !Utils.isEmptyString(field.form)
        });
        if(!isSelectForm){
            setIsShowEditTagField(false)
            setIsShowExportMenu(false)
        }
        setIsIncludeAttachPdf(viewStructure?.options?.isIncludeAttachPdf === 1);
        setIsSearchSynonym(viewStructure?.options?.isSearchSynonym === 1);
        if(viewStructure?.options?.isSearchSynonym !== 1){
            setIsDisableSimilarSearch(false)
        }

        const method = viewStructure?.options?.method;
        const isMethodSimilar = method && method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
        const isOptionSearchSynonym = viewStructure?.options?.isSearchSynonym === 1;

        setIsDisableSynonymSearch(isMethodSimilar && !isOptionSearchSynonym);
        setIsDisableIncludeAttachPdf(isMethodSimilar && !isOptionSearchSynonym);
        setIsDisableSimilarSearch(!isMethodSimilar && isOptionSearchSynonym);

        if (viewStructure?.options?.filePdfId) {
            //&& viewStructure?.options?.filePdfId !== previousViewStructure?.options?.filePdfId) {
            (async () => {
                let params = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.GET_OUTLINE_FIELD,
                    ticketId: viewStructure?.options?.filePdfId
                };
            
                let result = await getPublicAPI(props?.API, params);
                if (result.success) {
                    let data = Utils.convertJSONDataToObject(result.payload);
                    setFileNamePdfSelect(data);
                }
            })();
        } else {
            setFileNamePdfSelect('');
        }

    },[viewStructure]);

    
    useEffect(() => {
        let listSystemPdfField = drilldownDataSelected?.filter(item => {
            return item.isPdfSystemFile ? true : false;
        });
        let tagFields = cloneDeep(viewStructure.tagFields);
        let isEnablePdf = checkIsEnablePdfFunction();
        if (!isEnablePdf) {
            listSystemPdfField?.forEach(drillDownItem => {
                tagFields = tagFields?.filter(item => {
                    if (item.hasOwnProperty(drillDownItem.id)) {
                        return false;
                    }

                    return true;
                });
            });
            let newViewStructure = cloneDeep(viewStructure);
            newViewStructure.tagFields = tagFields;
            setViewStructure(newViewStructure)

        }
        // console.log('drilldownDataSelected :>> ', drilldownDataSelected);
        setDrillDownDataForLog(drilldownDataSelected)
    }, [drilldownDataSelected]);


    const checkIsEnablePdfFunction = () => {
        let isEnablePdf = false;
        if([Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)){
            const inviterSetting = Utils.convertJSONDataToObject(corporationDetail.inviterSetting);
            isEnablePdf = inviterSetting.convertPDF;
        }else{
            isEnablePdf = corporationDetail?.limitValue?.convertPDF
        }

        return isEnablePdf == 1
    }

    const closeIconBreadCrumb = () => {
        setFileNamePdfSelect('');
        setViewStructure(previousViewStructure);
        setPreviousViewStructure(previousViewStructure);
        setTriggerSearch(Date.now().toString());
    }

    const isShowIconBreadCrumb = () => {
        return fileNamePdfSelect && isConvertPdf
    }

    // argsCommon
    let argsCommon = {
        ...props,
        createTicketTypePopover,
        setCreateTicketTypePopover,
        settingSlideRecoilState,
        setSettingSlideRecoilState,
        nodeListView,
        element,
        setIsOpenModalReloadPage: setIsOpenModalReloadPage,
        setContentModalReloadPage,
        API: props?.API,
        userDetail: userDetail,
        projectInuseDetail,
        pagination,
        setPagination,
        isLoading: isLoading,
        setIsLoading: setIsLoading,

        isLoadingView,
        setIsLoadingView,

        ticketKnowledgeList: ticketKnowledgeList,
        setTicketKnowledgeList: setTicketKnowledgeList,

        updatePanelAfterCreateTicket: useSetRecoilState(updatePanelAfterCreateTicketSelector),
        addNewPanel,

        projectSelectedId: projectSelectedId,
        corporationSelectedId: corporationSelectedId,
        organizationProject,
        setOrganizationProject,
        organizationSelected,
        setOrganizationSelected,
        projectSelected,
        setProjectSelected,
        // visibilitySetting,
        // setVisibilitySetting,
        viewSelected,
        setViewSelected,
        listView,
        setListView,
        userRoleInProject,
        setUserRoleInProject,
        openListViewHide,
        setOpenListViewHide,

        viewStructure,
        setViewStructure,
        drilldownDataSelected,
        setDrillDownDataSelected,

        keywordSearch,
        setKeywordSearch,

        setTriggerSearch,

        isCustomer: isCustomer,
        customerId: customerId,
        panelId: props.panelId,

        panelList,
        setPanelList,
        setAddViewPopover,

        setOptionSearchTimeRange,

        setOptionSearchTimeAgo,

        isOpenDialogViewNameError,
        setIsOpenDialogViewNameError,
        isOpenDialogViewChanged,
        setIsOpenDialogViewChanged,

        viewNameErrorType,
        setViewNameErrorType,
        inputViewNameRef,

        drillDownData,
        setDrillDownData,
        defaultDrillDownData,
        setDefaultDrillDownData,

        sugguestionList,
        setSugguestionList,
        inputKeyWordRef,

        // share status
        shareStatusPopover,
        setShareStatusPopover,
        openShareStatusPopover,
        idPopoverShareStatus,
        setOpenShareStatusPopover,
        shareStatusData,
        setShareStatusData,
        reloadTicketListByPanelType,
        reloadTabItemInPanel,
        isOpenAlertDialog,
        setIsOpenAlertDialog,

        ticketIdList: ticketIdList,
        enqueueSnackbar,
        setTotalTickets,
        lastUserAction,
        setRemovedTagItem,
        setLastUserAction,
        setSearchTagSuggestKnowledge,
        searchTagSuggestKnowledge,
        searchContainAnyKnowledge,
        searchNotIncludeKnowledge,
        isKnowledge,
        corporationDetail,
        optionsSort,
        setOptionsSort,
        setCorporationDetail,
        setIsDisableSimilarSearch,
        setIsDisableSynonymSearch,
        setFileNamePdfSelect,
        visibilityKnowledgeAtom,
        isIncludeAttachPdf,
        setIsIncludeAttachPdf,
        setIsDisableIncludeAttachPdf,
        setCurrentSearchParams,
        // setIsHasEditPermissionEveryTicket,
        setIsHasEditPermissionSomeTicket,
        setListAdditionalAllRole,
        setListDataPublicRange,
        setIsLoadDataForPublicRangeDone,

        destinationPrjId,
        setDestinationPrjId,
        chatbotCategories,

        showLoadingMouse
    };

    // init data organization project
    const initDataOrganizationProject = async () => {
        try {
            setIsLoadingView(true);

                if (Utils.isEmptyObject(organizationProject)) {
                    setIsLoadingView(false);
                    return;
                }

                let visibility = '';
                if (organizationProject.value !== Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
                    visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
                    if (organizationProject.corpId === corporationDetail.id && !Utils.isB2CUser(userDetail)) {
                        visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
                    }
                } else {
                    const isOpenFromChatAI =  !Utils.isEmptyObject(props.knowledgeInfoChatAi);
                    if(isOpenFromChatAI) {
                        visibility = props?.visibilitySettingType ?  props?.visibilitySettingType : Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
                    } else {
                        visibility = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
                    }
                    //Check role user in projectSelected

                    await getUseRoleInProject(argsCommon, userDetail.id, projectSelectedId);
                    setVisibilitySettingListOption(listOptionViewVisibilityInitData);
                    setVisibilityKnowledgeAtom(visibility);
                }
    
                let listViewRes = await getListViews(argsCommon, projectSelectedId, visibility, knowledgeInfoChatAi, setIsScrollNewViews);
                setKnowledgeInfoChatAi(null);
                if(props.isOpenFromChatAI) {
                    let projectSelectedKnowledgeId = await getFirstProjectWhenOpenChatAI(props?.API, userDetail, corporationDetail, projectInuseDetail);
                    let listViews = await getViewDefaultsChatAI(props?.API, projectSelectedKnowledgeId, userDetail);
                    let firstView = {};
                    let structure = {};
                    if(!Utils.isEmpty(listViews)) {
                        firstView = listViews[0];
                        let visibilityDefault = getVisibilityDefault(corporationDetail, projectInuseDetail)
                        structure = Utils.convertJSONDataToObject(firstView?.structure);
                        structure.visibility = visibilityDefault;
                    }

                    if(projectSelectedKnowledgeId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
                        let visibilityFirstView = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
                        if (organizationProject.corpId === corporationDetail.id && !Utils.isB2CUser(userDetail)) {
                            visibilityFirstView = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
                        }
                        firstView ={
                            structure: {
                                ...Constant.DEFAULT_VIEW_STRUCTURE,
                                visibility: visibilityFirstView
                            }
                        }
                    }

                    let propsClone = {...props};
                    delete propsClone.panelId;

                    const newThreadId = `ai_chat_thread_${uuidv4()}`;
                    const filterKnowledgeListData = {
                        viewSelectedId: firstView?.id,
                        viewSelected: firstView,
                        viewStructure: Utils.convertJSONDataToObject(firstView?.structure),
                        projectIdKnowledgeSelected: projectSelectedKnowledgeId,
                        resetSearchCondition: true,
                        usingBasicPrompt: true,
                        isInvalidPrecondition: false,
                        threadId: newThreadId,
                        chatThreadId: newThreadId,
                        projectSelectedId: projectSelectedId,
                        hitNumber: totalTickets,
                    }
                    const chatThreadDto = {
                        id: newThreadId,
                        chatThreadId: newThreadId,
                        corporationId: corporationDetail.id,
                        affiliationProject: projectSelectedKnowledgeId,
                        clientUUId: `client_uuid_${uuidv4()}`,
                        creatorId: userDetail.id,
                        metaData: { filterKnowledgeListData: JSON.stringify(filterKnowledgeListData) }
                    }

                    let currentPanelList = cloneDeep(panelList);
                    if (Utils.isEmptyArray(currentPanelList)) return;
                    let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, currentPanelList);
                    if (currentPanelIndex === -1) return;

                    let currentPanel = currentPanelList[currentPanelIndex];

                    if (Utils.isEmptyArray(currentPanel.tabList)) return;
                    // Update ticket outline
                    currentPanelList[currentPanelIndex].tabList[
                        0
                    ].component.props.isOpenFromChatAI = false;
                    setPanelList([...currentPanelList]);
            
                    const newThreadChat = await createNewAIChatThread(chatThreadDto);
                    if (!Utils.isEmptyObject(newThreadChat)) {
                        let tabId = `${Constant.TAB_PANEL_TYPE.NEW_TAB_CHAT_AI}_${Date.now().toString()}`;
                
                        // let optionSearch = {
                        //     methodSearch: Constant.SETTING_SEARCH_KEYWORD.AND,
                        //     attributeSearch: Constant.SETTING_SEARCH_KEYWORD.MUTIPLE,
                        //     keywordList: []
                        // };
                        // const panelChatAI = currentPanelList.find(panel => panel.type === Constant.PANEL_TYPE.OPEN_CHAT_AI);
                        // let tabIndex = panelChatAI ? panelChatAI.tabList.length : 0;
                        // let tabName = `タブ${tabIndex + 1}`
                
                        // let dataLog = {
                        //     searchTagSuggestKnowledge: '',
                        //     viewName: firstView.name,
                        //     hitNumber: 0,
                        //     aiTabChatName: `${tabName} ${tabId}`
                        // }
                        
                        // let logKibanaData = createKibanaDataAIChat(dataLog, optionSearch, corporationDetail, projectInuseDetail, userDetail);
                        
                        // let dataGetHitNumber = createDataGetHitNumber(firstView, corporationDetail, projectInuseDetail, userDetail);
                        // let param = {
                        //     logType: LogKibanaConstant.AI_CHAT.SEARCH_CONDITION_SETTING,
                        //     logKibanaData: logKibanaData,
                        //     dataGetHitNumbers: dataGetHitNumber
                        // };
                        // createKibanaLogAPI(argsCommon.API, param);
                        
                        addNewPanel({
                            type: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                            tabId: tabId,
                            filterKnowledgeListData: filterKnowledgeListData,
                            chatThreadId: newThreadId,
                            props: propsClone
                        });
                    }
                }

                if (Utils.isEmptyArray(listViewRes)) {
                    setListView([]);

                    // resetViewStructure();
                    if (
                        projectSelectedId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG &&
                        !Utils.isEmptyObject(knowledgeInfoChatAi?.viewStructure)
                    ) {
                        setViewStructure(knowledgeInfoChatAi?.viewStructure);
                    } else {
                        setViewStructure({
                            ...Constant.DEFAULT_VIEW_STRUCTURE,
                            visibility: visibility
                        });
                    }

                }
                // if (isViewAllKnowledgeInCorporation(organizationProject)) {
                //     setTriggerSearch(Date.now().toString());
                // }
            // }

            setIsLoadingView(false);
        } catch (error) {
            setIsLoadingView(false);
            console.log('initDataOrganizationProject >>>', error);
        }
    };

    // Check convertPdf in CorpRoot by selectedProject
    useEffect(() => {
        if (!Utils.isEmptyObject(viewKnowledgeProjectSelected)) {
            (
                async () => await Utils.isUsingFunctionService(
                    viewKnowledgeProjectSelected,
                    corporationDetail,
                    'convertPDF',
                    setIsConvertPdf
                )
            ) ()
        }
      
    }, [viewKnowledgeProjectSelected]);
      

    useEffect(() => {
        autoScrollToActiveTab();
    },[panelList, element, nodeListView]);

    const formIdSearchConditionFilterBy = () => {
        const fields = !Utils.isEmptyArray(viewStructure?.fields) ? viewStructure?.fields : [];
        // console.log('fields :>>--------- ', fields);
        const indexOfSelectedForm = fields?.find(field => {
            return !Utils.isEmptyString(field?.form)
        });

        return indexOfSelectedForm && indexOfSelectedForm['form'] ? indexOfSelectedForm['form'] : '';
    }

    
    // Check convertPdf in CorpRoot by selectedProject
    useEffect(() => {
        const controller9 = new AbortController();
        initDataForBulkActionTagField()
        
        return () => {
            controller9.abort();
        }
    }, [drillDownData, isHasEditPermissionSomeTicket, viewStructure?.fields?.length, destinationPrjId]);

    const initDataForBulkActionTagField = async () => {
        let allTagFieldForBulkAction = [];
        let promiseGetData = [getAllBookmarkUserCanUse(userDetail.id, projectInuseDetail.id, Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE)];

        setLoadingBulkItemListTagField(true);

        let selectedForm = drillDownData?.find(drillDownDataItem => {
            return drillDownDataItem.id === 'form';
        });

        if (!Utils.isEmptyObject(selectedForm) && formIdSearchConditionFilterBy() && isHasEditPermissionSomeTicket) {
            const child = selectedForm.child;
            const formId = child[0]?.id;
            if (formId !== selectedFormId) {
                setSelectedFormId(formId);
            }
            if(!Utils.isEmptyString(formId)) {
                promiseGetData.push(getListTagFieldOfForm(formId, userDetail, projectInuseDetail, corporationDetail, setSelectedFilterForm, destinationPrjId));
            }
        }

        let getDataTagResponse = await Promise.all(promiseGetData);
        let allBookmark = getDataTagResponse[0];

        if (!Utils.isEmptyArray(getDataTagResponse) && getDataTagResponse.length === 2) {
            let listTagField = getDataTagResponse[1];
            if (!Utils.isEmptyArray(listTagField)) {
                listTagField.forEach(tagField => {
                    let fieldata = {
                        ...tagField,
                        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagField.name)
                    };
                    allTagFieldForBulkAction.push(fieldata);
                })
            }
        }

        if (!Utils.isEmptyArray(allBookmark)) {
            allBookmark = Utils.sortListByNameDictionaryASC(allBookmark);
            allTagFieldForBulkAction.push({
                id: [Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK, Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK],
                name: I18n.get('BOOKMARK_TAG'),
                listItem: allBookmark,
                isBookmark: true
            })
        }

        setListTagFieldOfForm([...allTagFieldForBulkAction]);

        setLoadingBulkItemListTagField(false)
    }

    const autoScrollToActiveTab = () => {
        if (!element || !nodeListView || Utils.isEmptyArray(nodeListView)) return;
        let nodeListViews = document.querySelectorAll('.item-knowledge');
        if(!Utils.isEmptyArray(nodeListViews)) {
            if(isScrollNewViews) {
                let containerRect = element.getBoundingClientRect();
                let posElem = [];
                for (let i = 0; i < nodeListView.length; i++) {
                    // Gets the amount of pixels currently visible within the container
                    let visiblePageWidth = getVisibleWidth(nodeListView[i]);
                    posElem.push({ pos: visiblePageWidth });
                }
                element.scrollLeft +=
                    posElem[posElem.length - 1].pos.width -
                    (containerRect.width - posElem[posElem.length - 1].pos.left);
                setIsScrollNewViews(false);
            }
        }
    }

    const clearMemoryLoadTicketList = () => {
        argsCommon = {};
        addNewPanel = {};
        setTicketIdList([]);
        setTicketKnowledgeList([]);
        setIsLoadingView(false);
        setOrganizationSelected({});
        setProjectSelected({});
        setOrganizationProject({});
        setDrillDownDataSelected([]);
        setDrillDownData([]);
        setSugguestionList([]);
        setDefaultDrillDownData([]);
        setUserFootprintList([]);
        setShareStatusData([]);
        setSearchTagSuggestKnowledge([]);
        setKnowledgeInfoChatAi({});

        setViewSelected({});
        setListView([]);
        setListTagFieldOfForm([]);
    }

    useEffect(() => {
        const controller1 = new AbortController();
        (async () => {
            try {
                const isOpenFromChatAI =  !Utils.isEmptyObject(props.knowledgeInfoChatAi);

                setIsInitData(true);
                //get data organizationProject;
                const organizationRes = await getInitDataOrganizationProject(
                    props?.API,
                    userPermissionView,
                    projectInuseDetail,
                    corporationDetail,
                    setVisibilityKnowledgeAtom,
                    setIsShowVisibilityKnowledgeAtom,
                    setProjectSelectedId,
                    setViewKnowledgeProjectSelected,
                    setCorporationSelectedId,
                    projectSelectedId,
                    corporationSelectedId,
                    isCustomer,
                    isOpenFromChatAI,
                    setOrganizationProject
                )

                if (!Utils.isEmptyObject(organizationRes)) {
                    if (!isOpenFromChatAI) {
                        if (organizationRes.value === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
                            setTriggerSearch(Date.now().toString());
                            setDestinationPrjId('');
                        } else if (organizationRes.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
                            setDestinationPrjId(projectInuseDetail.id);
                        } else {
                            setDestinationPrjId(organizationRes.value || '');
                        }
                    } else {
                        const propsKnowledgeInfoChatAI = props.knowledgeInfoChatAi;
                        const ticketCreatedProjectId = propsKnowledgeInfoChatAI.ticketCreatedProjectId;
                        setDestinationPrjId(ticketCreatedProjectId);
                    }
                }
                setIsInitData(false);
            } catch (error) {
                console.log('getInitDataOrganizationProject >>>', error)
                setIsInitData(false);
            }
        })();

        return () => {
            controller1.abort();
            clearMemoryLoadTicketList();
        }
    },[userPermissionView?.type]);

    useEffect(() => {
        const controller2 = new AbortController();
        const getListViewWhenChangeVisibility = async () => {
          if (
            organizationProject.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE &&
            visibilityKnowledgeAtom && !isCustomer
        ) {
            onChangeVisibilitySetting(visibilityKnowledgeAtom, argsCommon);
            await getListViews(argsCommon, projectSelectedId, visibilityKnowledgeAtom, knowledgeInfoChatAi, setIsScrollNewViews);
            setKnowledgeInfoChatAi(null);
          }
        };
      
        getListViewWhenChangeVisibility();

        return () => {
            controller2.abort();
        }
    }, [visibilityKnowledgeAtom]);

    useEffect(() => {
        const controller3 = new AbortController();
        if (masterKnowledgeHyperLink.isReload) {
            setProjectSelectedId(masterKnowledgeHyperLink.projectSelectedId);
            setCorporationSelectedId(masterKnowledgeHyperLink.corporationSelectedId);

            setIsCustomer(masterKnowledgeHyperLink.isCustomer);
            setCustomerId(masterKnowledgeHyperLink.customerId);
            setTicketIdList(masterKnowledgeHyperLink.ticketIdItemList);
            setMasterKnowledgeHyperLinkStatus(masterKnowledgeHyperLink.masterKnowledgeHyperLink);
            setVisibilitySettingType(masterKnowledgeHyperLink.visibilitySettingType);

            // init data
            initDataOrganizationProject();
        }

        return () => {
            controller3.abort();
        }
    }, [masterKnowledgeHyperLink]);

    useEffect(() => {
        const controller4 = new AbortController();
        // init when has view
        initDataOrganizationProject();

        return () => {
            controller4.abort();
        }
    }, [
        // projectSelectedId,
        // corporationSelectedId,
        isCustomer,
        customerId,
        masterKnowledgeHyperLinkStatus,
        visibilitySettingType,
        userPermissionView,
        organizationProject,
    ]);

    useEffect(() => {
        const projectSetting = Utils.convertJSONDataToObject(projectInuseDetail.projectSetting);
        if(!Utils.isEmptyObject(projectSetting)) {
            let usingSynonym = projectSetting?.usingSynonym;
            if(!usingSynonym && viewStructure?.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
                let listViewNotIncludesSynonym = listView.filter(view => {
                    let structure = Utils.convertJSONDataToObject(view.structure);
                    return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM
                });

                if(!Utils.isEmptyArray(listViewNotIncludesSynonym)) {
                    onChangeViewSelected(
                        listViewNotIncludesSynonym[0],
                        { ...argsCommon, clickTimeout, setClickTimeout },
                        corporationDetail
                    );
                }
            }
        }

    },[projectInuseDetail])

    useEffect(() => {
        setIsShowEditTagField(false);
        setIsShowEditRangeMulti(false);
        setIsShowExportMenu(false)
    }, [viewSelected, visibilityKnowledgeAtom]);

    // viewSelected change
    useEffect(() => {
        const controller5 = new AbortController();
        if( !Utils.isEmptyObject(viewSelected)) {
            let newViewStructure = Utils.convertJSONDataToObject(viewSelected?.structure);
            if (newViewStructure && typeof newViewStructure === 'object') {
                getDrilldownItemDataSelected(props?.API, newViewStructure).then(drillDownDataRes => {
                    setDefaultSelectedOption(
                        !Utils.isEmptyArray(drillDownDataRes) ? drillDownDataRes : []
                    );
                });
            }
    
            if (lastUserAction !== LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE) {
                setLastUserAction(LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE);
                setSearchTagSuggestKnowledge([]);
            }

            setAtomKnowledgeViewSelected(viewSelected);
        }

        if (!Utils.isEmptyObject(viewStructure)) {
            let clonedStructure = {...viewStructure}
            // delete clonedStructure.visibility
            if (viewStructure.options.method) {
                let newOptions = {...clonedStructure.options}

                switch (viewStructure.options.method) {
                    case Constant.SETTING_SEARCH_KEYWORD.AND:
                        newOptions = Object.fromEntries(
                            Object.entries(clonedStructure.options).filter(([key, value]) =>
                                !(['method'].includes(key) ||
                                  (['isSearchSynonym', 'isIncludePdfFile', 'isIncludePdfPage', 'isIncludeAttachPdf'].includes(key) && value !== 1))
                            )
                        );

                        break;
                    case Constant.SETTING_SEARCH_KEYWORD.OR:
                        newOptions = Object.fromEntries(
                            Object.entries(clonedStructure.options).filter(([key, value]) =>
                                !((['isSearchSynonym', 'isIncludePdfFile', 'isIncludePdfPage', 'isIncludeAttachPdf'].includes(key) && value !== 1))
                            )
                        );
                        
                        break;
                    case Constant.SETTING_SEARCH_KEYWORD.SIMILAR:
                        newOptions = Object.fromEntries(
                            Object.entries(clonedStructure.options).filter(([key, value]) =>
                                !((['isIncludePdfFile', 'isIncludePdfPage', 'isIncludeAttachPdf'].includes(key) && value !== 1))
                            )
                        );

                        break;
                    default:
                        break;
                };

                clonedStructure = {
                    ...clonedStructure,
                    options: newOptions
                }
            }
            setListenOnChangeKnowledgeViewSelected(prev => ({
                ...viewSelected,
                structure: JSON.stringify({...clonedStructure})
            }));
        }

        return () => {
            controller5.abort();
        }
    }, [viewSelected, viewStructure]);

    useEffect(async () => {
        const controller6 = new AbortController();
        if (!isViewAllKnowledgeInCorporation(organizationProject) && Utils.isEmptyObject(organizationProject)) return;
        if (!isViewAllKnowledgeInCorporation(organizationProject) && Utils.isEmptyObject(viewSelected)) return;
        //check view was changed
        const existsView = listView.some(item => item.id === viewSelected.id);
        if (!isViewAllKnowledgeInCorporation(organizationProject) && !Utils.isEmptyObject(viewSelected) && existsView) {
            isViewWasChanged(viewSelected, argsCommon).then(isViewChanged => {
                if (isViewChanged) {
                    setIsOpenDialogViewChanged(true);
                    return () => {
                        controller6.abort();
                    }
                }
            });
        }

        if(viewStructure?.options?.filePdfId) {
            let ticketFilePdf = await getTicketById(props.API, viewStructure?.options?.filePdfId)

            const attachment = ticketFilePdf?.attachment;
            const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
            if (
                Utils.isEmptyObject(ticketFilePdf) ||
                (ticketFilePdf?.deletedAt && structure.ticketProperty !== Constant.TICKET_PROPERTY.DELETE) ||
                !attachment[0]?.splitPdf ||
                (structure.ticketProperty === Constant.TICKET_PROPERTY.SENT &&
                    ticketFilePdf.public === Constant.TICKET_PUBLIC.DRAFT) ||
                (structure.ticketProperty === Constant.TICKET_PROPERTY.DRAFT &&
                    ticketFilePdf.public === Constant.TICKET_PUBLIC.PUBLIC) ||
                (structure.ticketProperty === Constant.TICKET_PROPERTY.DELETE &&
                    !ticketFilePdf?.deletedAt)
            ) {
                closeIconBreadCrumb();
                return () => {
                    controller6.abort();
                }
            }
           
        }

        if (!Utils.isEmptyObject(organizationProject)) {
            // get ticket knowledge list
            handleGetTicketKnowledge();
            
            // get drilldown data
            await handleGetDrilldownData();
        }

        return () => {
            controller6.abort();
        }
    }, [
        // organizationProject,
        // isCustomer,
        viewStructure.fields.length,
        viewStructure.statusFields?.length,
        viewStructure.tagFields?.length,
        viewStructure.privateBookmark?.length,
        viewStructure.sharedBookmark?.length,
        viewStructure.keyword,
        props.triggerReload,
        triggerSearch,
        // viewStructure.visibility,
        viewSelected.id,
        organizationProject,
        destinationPrjId,
    ]);

    // #77576: Reload commom data panel when click knowlead icon from knowlead chat
    useEffect(() => {
        if (reloadPanelId === props.panelId) {
            if (projectSelectedId !== props.projectSelectedId) {
                setProjectSelectedId(props.projectSelectedId);
            } else {
                if (listView[0]?.id !== viewSelected?.id) {
                    setViewSelected(listView[0]);
                }
            }
            setReloadPanelId('');
        }
    }, [reloadPanelId]);

    useEffect(() => {
        if (process.env.NODE_ENV !== 'development') {
            // let appDomain = process.env.REACT_APP_DOMAIN_NAME || '';
            let timeInterval = 15 * 60 * 1000;  // 15 mins
            // if (appDomain && appDomain.includes('dbdesk-test.ominext.dev')) {
            //     timeInterval = timeInterval*10;
            // }
            const reloadTicketLists = setInterval(() => setTriggerInterval(Date.now().toString()), timeInterval);
            window.reloadKnowledgeTickets = reloadTicketLists;
            return () => clearInterval(reloadTicketLists);
        }
    }, []);

    useEffect(async () => {
        const controller7 = new AbortController();
        if (triggerInterval) {
            const argsReloadTicket = {
                API: props?.API,
                setIsLoading,
                viewStructure,
                visibilityKnowledgeAtom,
                corporationSelectedId,
                setKeywordSearch,
                setTicketKnowledgeList,
                setPagination,
                ticketKnowledgeList: ticketKnowledgeList,
                pagination: pagination,
                userDetail: userDetail,
                setDrillDownDataSelected,
                keywordSearch,
                setOptionSearchTimeAgo,
                setOptionSearchTimeRange,
                inputKeyWordRef,
                projectSelectedId,
                projectInuseDetail,
                setTotalTickets,
                viewSelected,
                corporationDetail,
                destinationPrjId
            }
            if(viewStructure?.options?.filePdfId) {
                let ticketFilePdf = await getTicketById(props.API, viewStructure?.options?.filePdfId)
    
                const attachment = ticketFilePdf?.attachment;
                const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
                if (
                    Utils.isEmptyObject(ticketFilePdf) ||
                    (ticketFilePdf?.deletedAt && structure.ticketProperty !== Constant.TICKET_PROPERTY.DELETE) ||
                    !attachment[0]?.splitPdf ||
                    (structure.ticketProperty === Constant.TICKET_PROPERTY.SENT &&
                        ticketFilePdf.public === Constant.TICKET_PUBLIC.DRAFT) ||
                    (structure.ticketProperty === Constant.TICKET_PROPERTY.DRAFT &&
                        ticketFilePdf.public === Constant.TICKET_PUBLIC.PUBLIC) ||
                    (structure.ticketProperty === Constant.TICKET_PROPERTY.DELETE &&
                        !ticketFilePdf?.deletedAt)
                ) {
                    closeIconBreadCrumb();
                    return () => {
                        controller7.abort();
                    }
                }
               
            }
            autoReloadTicket(argsReloadTicket);
            handleGetDrilldownData();
        }

        return () => {
            controller7.abort();
        }
    }, [triggerInterval]);

    useEffect(() => {
        const controller8 = new AbortController();
        (async () => {
            let isShowIconChatAI = await isDisplayIconChatAIOnKnowledgeList(
                props?.API,
                userPermissionView,
                corporationDetail,
                projectInuseDetail,
                organizationProject
            )
            setIsDisplayIconChatAI(Boolean(isShowIconChatAI));
        })();

        return () => {
            controller8.abort();
        }
    },[organizationProject, projectInuseDetail])

    // handle display bookmark
    useEffect(() => {
        let ticketProperty = Constant.TICKET_PROPERTY.SENT;
        const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
        if (!Utils.isEmptyObject(structure)) {
            ticketProperty = structure?.ticketProperty;
        }

        const isDeleteView = ticketProperty === Constant.TICKET_PROPERTY.DELETE
        setIsViewDelete(isDeleteView)
        

    }, [organizationProject, viewSelected])
    
    useEffect(() => {
        const controller9 = new AbortController();

        (async () => {
            const chatbotCategories = await getCategoryListOfProject(
                props?.API,
                projectInuseDetail?.id
            );
            if (!Utils.isEmptyArray(chatbotCategories)) setChatbotCategories(chatbotCategories);
        })();

        return () => {
            controller9.abort();
        };
    }, [projectInuseDetail]);

    const handleGetTicketKnowledge = (paginationFrom = 0, paginationSize = 20) => {
        setIsLoading(true);
        getListTicketKnowledge(
            argsCommon, 
            paginationFrom, 
            paginationSize, 
            lastUserAction, 
            corporationDetail, 
            projectInuseDetail, 
            userDetail, 
            searchContentType, 
            searchTagSuggestKnowledge,
            removedTagItem, 
            setRemovedTagItem
        );
    };

    const handleGetDrilldownData = async () => {
        setIsLoadingDrillDown(true);
        setIsLoadDrillDown(true);
        let ticketProperty = viewStructure.ticketProperty;
        if (!ticketProperty && !Utils.isEmptyObject(viewSelected)) {
            let viewSelectedStructure = Utils.convertJSONDataToObject(viewSelected.structure);
            ticketProperty = viewSelectedStructure?.ticketProperty;
        }

        if (!ticketProperty) {
            ticketProperty = Constant.TICKET_PROPERTY.SENT;
        }
        let visibility = viewStructure.visibility
            ? viewStructure.visibility
            : visibilityKnowledgeAtom;
        
            if (corporationSelectedId !== corporationDetail?.id || Utils.isB2CUser(userDetail)) {
                visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
            }

        let filterParams = {
            corporationId: corporationSelectedId ? corporationSelectedId : localStorageUtil.getAffiliationOrganization(),
            projectId: projectSelectedId,
            userId: localStorageUtil.getUserDetailId(),
            isCustomer: isCustomer,
            visibility: visibility,
            viewStructure: {
                ...viewStructure,
                ticketCreatedProjectId: destinationPrjId
            },
            ticketProperty: ticketProperty,
            from: 0,
            size: 2000,
            projectInuse: projectInuseDetail?.id || localStorageUtil.getSelectedProjectId(),
            userAffiliationOrganization: corporationDetail?.id || localStorageUtil.getAffiliationOrganization(),
            projectInuseType: projectInuseDetail?.type || localStorageUtil.getSelectedProjectType(),
        };

        // Get default drilldown data for list option include/exclude
        let defaultViewStructure = cloneDeep(Constant.DEFAULT_VIEW_STRUCTURE);
        defaultViewStructure.visibility = visibility;
        defaultViewStructure.ticketCreatedProjectId = viewStructure.ticketCreatedProjectId;

        let defaultFilterParams = { ...filterParams, viewStructure: defaultViewStructure };

        // Fix for search all knowledge in org
        // if (!destinationPrjId && corporationDetail?.id === organizationProject?.corpId && !Utils.isB2CUser(userDetail)) {
        //     filterParams.visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
        //     defaultFilterParams.visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
        // }
        const [drillDownDataResult] = await Promise.all([
            // get current drillDownData
            getCurrentDrilldownData(argsCommon, filterParams, false, setCurrentSearchParams),
            getDataPublicRange(argsCommon, filterParams)
        ]);
        setDrillDownData(drillDownDataResult.drillDownData);
        setSugguestionList(drillDownDataResult.sugguestionList);
        
        setIsLoadingDrillDown(false);
        setIsLoadDrillDown(false);

        const resDefaultDrillDownData = await getCurrentDrilldownData(argsCommon, defaultFilterParams, true)
        setDefaultDrillDownData(resDefaultDrillDownData.drillDownData);
    };

    const getNextPage = () => {
        const paginationClone = { ...pagination };
        paginationClone.from = paginationClone.from + 20;
        // setPagination(paginationClone);
        handleGetTicketKnowledge(paginationClone.from, paginationClone.size);
        // setTriggerSearch(Date.now().toString());
    };


    const onClickAddNewView = async () => {
        let defaultVisibility = viewStructure.visibility
            ? viewStructure.visibility
            : visibilityKnowledgeAtom;

        // Fix for https://new.redmine.ominext.com/issues/222170
        // When search by page unit, change viewStructure => viewStructure.visibility is not correct.
        if (viewStructure?.options?.filePdfId && viewStructure?.options?.getListPdfPage && previousViewStructure?.visibility) {
            defaultVisibility = previousViewStructure?.visibility;
        }

        setIsLoading(true);
        setAddViewPopover(null);
        createNewView(argsCommon, defaultVisibility).then(() => {
            setIsLoading(false);
            let nodeListViews = document.querySelectorAll('.item-knowledge');
            let containerRect = element.getBoundingClientRect();
            let posElem = [];
            for (let i = 0; i < nodeListViews.length; i++) {
                // Gets the amount of pixels currently visible within the container
                let visiblePageWidth = getVisibleWidth(nodeListViews[i]);
                posElem.push({ pos: visiblePageWidth });
            }
            element.scrollLeft +=
                posElem[posElem.length - 1].pos.width -
                (containerRect.width - posElem[posElem.length - 1].pos.left);
        });
    };

    const handleClickOpenListViewHide = () => {
        let listViewHide = listView.filter(view => view.status === Constant.STATUS_VIEW.HIDDEN);
        if (!Utils.isEmptyArray(listViewHide)) {
            setOpenListViewHide(!openListViewHide);
        } else {
            setOpenListViewHide(false);
        }
    };

    const openChatThreadPanel = async (ticketDetail) => {
        ticketDetail = await getTicketById(props?.API, ticketDetail.id);

        if (userDetail?.id !== ticketDetail?.creator) {
            setIsLoading(true);
            let isValid = await hasKnowledgeChatPermissionInChatThread(
                ticketDetail,
                projectInuseDetail,
                userDetail?.id,
                false
            );
            setIsLoading(false);
            if (!isValid) {
                setIsOpenModalReloadPage(true);
                return;
            }
        }
        addNewPanel({
            //update
            type: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
            tabId: ticketDetail.id,
            props,
            ticketId: ticketDetail.id,
            ticketOutline: ticketDetail.outline,
            isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false
        });

        const newTicketList = ticketKnowledgeList.map(ticket => {
            if (ticket?.id === ticketDetail?.id) {
                return { ...ticket, totalUnreadMsg: 0 };
            }
            return ticket;
        });
        setTicketKnowledgeList(newTicketList);
    };

    const handleOpenFile = (event, fileUploadInfor, ticketDetail, isPdfFile = false) => {
        let item = {
            content: fileUploadInfor.fileName,
            fileSize: parseInt(fileUploadInfor.fileSize),
            fileUrl: fileUploadInfor.fileUrl,
            type: 1
        };
        downloadFileFromS3(item, ticketDetail,false,isPdfFile, '', setIsShowPopupLogout);
    };

    // render ticket knowledge item
    const renderTicketKnowledgeItem = ticketKnowledge => {
        let isAddtional = isAddtionalViewOrEdit(ticketKnowledge);
        let labelOfButtonShareStatus = isAddtional
            ? `${Constant.KNOWLEDGE_SHARE_STATUS_LABEL}+`
            : Constant.KNOWLEDGE_SHARE_STATUS_LABEL;
        let affiliationProjectInfo = ticketKnowledge?.affiliationProjectInfo;
        let projectName = `${Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            affiliationProjectInfo?.name
        )}`;

        // get affiliationOrganizationInfo;
        let affiliationOrganizationInfo = {};
        if (affiliationProjectInfo.affiliationOrganization === corporationDetail.id) {
            affiliationOrganizationInfo = corporationDetail;
        } else if (ticketKnowledge.affiliationOrganizationInfo) {
            affiliationOrganizationInfo = ticketKnowledge.affiliationOrganizationInfo;
        }
        let corporationNameSuffixText = Utils.getCorporationNameSuffixText(
            affiliationOrganizationInfo
        );
        if (corporationNameSuffixText) {
            projectName = `${projectName} (${corporationNameSuffixText})`;
        }

        // creator
        let creatorName = `${Utils.getUserNameWithActiveStatus(ticketKnowledge?.creatorInfo)}`;
        let suffixCreatorName = Utils.getCorporationNameSuffixText(
            ticketKnowledge?.creatorInfo?.affiliationOrganizationInfo
        );
        if (suffixCreatorName) {
            creatorName = `${creatorName} (${suffixCreatorName})`;
        }

        // updator
        let updatorName = `${Utils.getUserNameWithActiveStatus(ticketKnowledge?.updatorInfo)}`;
        let suffixUpdatorName = Utils.getCorporationNameSuffixText(
            ticketKnowledge?.updatorInfo?.affiliationOrganizationInfo
        );
        if (suffixUpdatorName) {
            updatorName = `${updatorName} (${suffixUpdatorName})`;
        }

        return (
            <div className={`knowledge-item-container ${ticketKnowledge.id}`}>
                <div className="knowledge-frame" key={ticketKnowledge.id}>
                    <div className="knowledge-head">
                        <div className="knowledge-head-absolute-wrap">
                            <Bookmark
                                isViewDelete={isViewDelete}
                                ticketKnowledge={ticketKnowledge}
                                isShowEdit={true}
                                isShowDefaultBookmark={false}
                            />
                            <TaggedBookmarkListName
                                bookmarkListText={ticketKnowledge?.bookmarkListText}
                                className="tagged-bookmark-knowledge-list-text"
                            />
                        </div>
                        <div className="knowledge-icon-frame knowledge-icon-frame-position-updated">
                            {hasKnowledgeChatPermission(ticketKnowledge, projectInuseDetail) &&
                                ticketKnowledge.public === Constant.TICKET_PUBLIC.PUBLIC && (
                                    <Badge
                                        overlap="rectangular"
                                        badgeContent={
                                            ticketKnowledge?.totalUnreadMsg > 0
                                                ? ticketKnowledge?.totalUnreadMsg
                                                : null
                                        }
                                        color="secondary"
                                        className="knowledge-chat-icon"
                                        onClick={() => openChatThreadPanel(ticketKnowledge)}
                                    >
                                        <img src="/assets/image/icon-chat.svg" alt="" />
                                    </Badge>
                                )}

                            {ticketKnowledge.public === Constant.TICKET_PUBLIC.PUBLIC &&
                                [
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT,
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER
                                ].includes(userPermissionView?.type) &&
                                projectInuseDetail.id === ticketKnowledge?.affiliationProject && (
                                    <div className="knowledge-btn">
                                        <div className="footprints ticket-outline">
                                            <Typography
                                                className="knowledge-footprint"
                                                aria-describedby={id}
                                                variant="contained"
                                                onClick={e =>
                                                    onHoverPopoverFootprint(
                                                        e,
                                                        ticketKnowledge,
                                                        setFootPrintPopover,
                                                        ticketKnowledgeList,
                                                        setUserFootprintList
                                                    )
                                                }
                                            >
                                                <span className="knowledge-item">
                                                    <img
                                                        src="/assets/image/icon-footprints.svg"
                                                        alt=""
                                                        className="knowledge-icon-frame-size"
                                                    />
                                                </span>
                                                <span className="number-count">
                                                    {ticketKnowledge.footPrint.length > 0
                                                        ? ticketKnowledge.footPrint.length >= 100
                                                            ? '99+'
                                                            : ticketKnowledge.footPrint.length
                                                        : '0'}
                                                </span>
                                            </Typography>
                                            {!Utils.isEmptyArray(ticketKnowledge?.footPrint) && (
                                                <Popover
                                                    className="numberView-sub"
                                                    id={idPopOverFootPrint}
                                                    open={openPopoverFootPrint}
                                                    anchorEl={footPrintPopover}
                                                    onClose={e => setFootPrintPopover(null)}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center'
                                                    }}
                                                >
                                                    <div
                                                        className="listView"
                                                        id={`footprint_id_${ticketKnowledge.id}`}
                                                    >
                                                        <ul>{userFootprintList}</ul>
                                                    </div>
                                                </Popover>
                                            )}
                                        </div>
                                    </div>
                                )}

                            <div className="bookmark-count">
                                <Bookmark
                                    isViewDelete={isViewDelete}
                                    ticketKnowledge={ticketKnowledge}
                                    isShowEdit={false}
                                    isShowDefaultBookmark={true}
                                    tagDefaultBookmarkClassName={
                                        'reset-position-list-bookmark-icon'
                                    }
                                />
                                <span className="bookmark-count-number">
                                    {ticketKnowledge.totalPrivateBookmark >= 100
                                        ? '99+'
                                        : ticketKnowledge.totalPrivateBookmark}
                                </span>
                            </div>
                        </div>
                        <div className="knowledge-info">
                            <div
                                className="knowledgeTitle ticket-outline titleDisplay"
                                onClick={e =>
                                    viewTicketKnowledgeDetail(
                                        argsCommon,
                                        ticketKnowledge.id,
                                        addNewPanel,
                                        setLastUserAction,
                                        true
                                    )
                                }
                            >
                                {/* <SDeskTooltip
                                    value={
                                        getTitle(ticketKnowledge?.settingTitle)
                                            ? getTitle(ticketKnowledge?.settingTitle)
                                            : '[概要 (現在未記入)]'
                                    }
                                    className="titleDisplay"
                                    isOverFlowTooltip={false}
                                /> */}

                                <Tooltip
                                    title={
                                        getTitle(ticketKnowledge?.settingTitle)
                                            ? generateDetatilTicketTitle(ticketKnowledge)
                                            : '[概要 (現在未記入)]'
                                    }
                                >
                                    <label
                                        className="titleDisplay titleTicket-titlev2 title-clamp"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {getTitle(ticketKnowledge?.settingTitle)
                                            ? generateDetatilTicketTitle(ticketKnowledge)
                                            : '[概要 (現在未記入)]'}
                                    </label>
                                </Tooltip>
                                <OverFlowTooltipWithTabsMui
                                    value={projectName}
                                    className="knowledgeTitle-proj"
                                />
                            </div>
                        </div>
                        {permissionChangeShareRangeStatus(
                            ticketKnowledge,
                            userDetail,
                            isProjectManager,
                            projectInuseDetail,
                            viewStructure
                        ) && (
                            <div className="knowledge-share-status">
                                <Typography
                                    className="knowledge-share-status-label"
                                    aria-describedby={idPopoverShareStatus}
                                    variant="contained"
                                    onClick={e =>
                                        handleClickShareStatus(
                                            e,
                                            ticketKnowledge,
                                            setShareStatusPopover,
                                            setOpenShareStatusPopover,
                                            argsCommon
                                        )
                                    }
                                    style={{
                                        marginTop: 10
                                    }}
                                >
                                    <span>{`${labelOfButtonShareStatus}`}</span>
                                </Typography>
                                <Popover
                                    className="share-status-popover"
                                    id={idPopoverShareStatus}
                                    key={`popover-share-status-${ticketKnowledge.id}`}
                                    open={openShareStatusPopover === ticketKnowledge.id}
                                    anchorEl={shareStatusPopover}
                                    onClose={e =>
                                        handleClosePopover(
                                            e,
                                            argsCommon,
                                            ticketKnowledge,
                                            shareStatusData
                                        )
                                    }
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'right'
                                    }}
                                >
                                    <div>
                                        <div
                                            className="listView knowledge-share-status-list"
                                            id={`share_status_id_${ticketKnowledge.id}`}
                                        >
                                            <FormControl
                                                component="fieldset"
                                                id={`form-control-share-status-${ticketKnowledge.id}`}
                                            >
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li share-status-li-checked`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}-formGroup`}
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .CREATOR_ONLY
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={true}
                                                                disabled={true}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .CREATOR_ONLY
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}`}
                                                    />
                                                </FormGroup>
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li share-status-li-checked`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}-formGroup`}
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_PROJECT
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={true}
                                                                disabled={true}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_PROJECT
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}`}
                                                    />
                                                </FormGroup>
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li${
                                                        isCheckedChangeStatusOption(
                                                            Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                .IN_ORG,
                                                            argsCommon
                                                        )
                                                            ? ' share-status-li-checked'
                                                            : ''
                                                    }`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG}-formGroup`}
                                                    onChange={e =>
                                                        handleClickChecked(
                                                            e,
                                                            argsCommon,
                                                            Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                .IN_ORG
                                                        )
                                                    }
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_ORG
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .IN_ORG,
                                                                    argsCommon
                                                                )}
                                                                disabled={
                                                                    !Utils.isEmptyString(
                                                                        ticketKnowledge.deletedAt
                                                                    )
                                                                }
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_ORG
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG}`}
                                                    />
                                                </FormGroup>
                                                {corporationDetail.deskService ===
                                                    Constant.STATUS_SERVICE_PERMISSION.ON && (
                                                    <>
                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_CUSTOMER,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_CUSTOMER
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_CUSTOMER
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .B2B_CUSTOMER,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_CUSTOMER
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER}`}
                                                            />
                                                        </FormGroup>
                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_SUPPORT,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_SUPPORT
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_SUPPORT
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .B2B_SUPPORT,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_SUPPORT
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT}`}
                                                            />
                                                        </FormGroup>

                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .PUBLIC,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .PUBLIC
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .PUBLIC
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .PUBLIC,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .PUBLIC
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC}`}
                                                            />
                                                        </FormGroup>
                                                    </>
                                                )}
                                            </FormControl>
                                            {isAddtional && (
                                                <div
                                                    className="share-status-popover-additional"
                                                    onClick={e =>
                                                        viewTicketKnowledgeDetail(
                                                            argsCommon,
                                                            ticketKnowledge.id,
                                                            addNewPanel,
                                                            setLastUserAction,
                                                            true
                                                        )
                                                    }
                                                >
                                                    <span className="share-status-item-additional">
                                                        {
                                                            Constant.KNOWLEDGE_SHARE_STATUS_LABEL_ADDITIONAL
                                                        }
                                                    </span>
                                                    <span className="share-status-item-additional">
                                                        <img
                                                            src="/assets/image/share-status-additional.svg"
                                                            alt=""
                                                        />
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        )}
                    </div>
                    <div className="knowledge-content">
                        <div className="knowledge-thumnail">
                            <ul className="thumnail-list">
                                {!Utils.isEmptyArray(ticketKnowledge.attachments) &&
                                    ticketKnowledge.attachments.map((file, index, array) => {
                                        getLinkDownloadFileFromS3(
                                            { ...file, type: 1 },
                                            ticketKnowledge,
                                            null,
                                            Constant.ATTACH_FILE.VIEW_TICKET
                                        );
                                        if (
                                            array.length > Constant.ATTACHMENT_DISPLAY_LIMIT &&
                                            index >= Constant.ATTACHMENT_DISPLAY_LIMIT - 1
                                        ) {
                                            return <></>;
                                        }
                                        const displayTextInFile = displayTagOfThumbAttach(
                                            ticketKnowledge,
                                            file.fileName
                                        );
                                        const isDisplayPdf = displayTextInFile.name == 'pdf';

                                        return (
                                            <>
                                                <Tooltip
                                                    title={file.fileName}
                                                    aria-label={file.fileName}
                                                    key={index}
                                                >
                                                    <li
                                                        className={`knowledge-attach ${
                                                            isDisplayPdf
                                                                ? 'knowledge-attach-pdf'
                                                                : ''
                                                        }`}
                                                    >
                                                        <img
                                                            src={
                                                                Utils.isImageFile(file.fileName)
                                                                    ? getLinkDownloadFileFromS3(
                                                                          { ...file, type: 1 },
                                                                          ticketKnowledge,
                                                                          null,
                                                                          Constant.ATTACH_FILE
                                                                              .VIEW_TICKET,
                                                                          false,
                                                                          false
                                                                      )
                                                                    : '/assets/image/others_file.png'
                                                            }
                                                            alt=""
                                                            aria-label="more"
                                                            aria-controls="long-menu"
                                                            aria-haspopup="true"
                                                            onClick={event =>
                                                                handleOpenFile(
                                                                    event,
                                                                    file,
                                                                    ticketKnowledge,
                                                                    isDisplayPdf
                                                                )
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                '--background-color-file':
                                                                    displayTextInFile.colorCode
                                                            }}
                                                        >
                                                            {displayTextInFile.name}
                                                        </span>
                                                    </li>
                                                </Tooltip>
                                                {isShowIconPageUnit(ticketKnowledge, file) && (
                                                    <Tooltip
                                                        title={I18n.get(
                                                            'LABEL-PAGE-KNOWLEDGE-UNIT'
                                                        )}
                                                        aria-label={I18n.get(
                                                            'LABEL-PAGE-KNOWLEDGE-UNIT'
                                                        )}
                                                        className="icon-triple-page"
                                                    >
                                                        <IconButton
                                                            onClick={async () => {
                                                                await handleSelectFilePdf(
                                                                    setPreviousViewStructure,
                                                                    setViewStructure,
                                                                    viewStructure,
                                                                    ticketKnowledge,
                                                                    file,
                                                                    isCustomer,
                                                                    setFileNamePdfSelect,
                                                                    setTriggerSearch,
                                                                    fileNamePdfSelect,
                                                                    corporationSelectedId,
                                                                    props.API,
                                                                    setIsOpenModalReloadPage,
                                                                    setIsLoading
                                                                );
                                                            }}
                                                        >
                                                            <img
                                                                src="/assets/image/triple_page.svg"
                                                                alt={displayTextInFile.name}
                                                            />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </>
                                        );
                                    })}
                                {ticketKnowledge?.attachments?.length >
                                    Constant.ATTACHMENT_DISPLAY_LIMIT && (
                                    <li className="wrapper-other-file">
                                        <a href="javascript:void(0)">
                                            <span className="knowledgeThumnail-number">
                                                {ticketKnowledge?.attachments?.length -
                                                    (Constant.ATTACHMENT_DISPLAY_LIMIT - 1)}
                                                +
                                            </span>
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                        <div className="knowledge-icon-frame">
                            {isDisplayEyeSlashIcon(
                                isCustomer,
                                visibilityKnowledgeAtom,
                                ticketKnowledge
                            ) && (
                                <div className="knowledge-btn-eye">
                                    <div className="chat">
                                        <span className="knowledge-item">
                                            <img src="/assets/image/icon-eye-slash.svg" alt="" />
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* <div className='knowledge-btn'>
                                <div className="my-favorite">
                                    <span className='knowledge-item'><img src="/assets/image/icon-star.svg" alt="" /></span>
                                    <span className="number-count">3</span>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="knowledge-footer">
                        <div className="knowledge-lst">
                            <div>
                                <p className="knowledge-date">{`作成日： ${Utils.getDateByFormatYYYY_MM_DD(
                                    ticketKnowledge.createdAt
                                )}`}</p>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-name"
                                    value={creatorName}
                                />
                            </div>
                        </div>

                        <div className="knowledge-lst">
                            <div>
                                <p className="knowledge-date">{`更新日： ${Utils.getDateByFormatYYYY_MM_DD(
                                    ticketKnowledge.updatedAt
                                )}`}</p>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-name"
                                    value={updatorName}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    //////////////////

    const handleOnScroll = event => {
        let elementWhenScroll = event.target;
        if (
            elementWhenScroll.offsetHeight + elementWhenScroll.scrollTop >= elementWhenScroll.scrollHeight &&
            pagination.lastTotal === 20
        ) {
            getNextPage();
        }
    };

    const isShowOptionSearchSimilar = () => {
        if(viewStructure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
            return false;
        }

        let isNotSearchChat = viewStructure.options.attribute !== Constant.SETTING_SEARCH_KEYWORD.COMMENT
        
        let usingChatAI = corporationDetail.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON ? true : false;
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)) {
            usingChatAI = corporationDetail.inviterUsingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON;
        }
        //TODO: Temporarily comment here and set its value to true
        let AIVectorizationCompleted = true
        // let AIVectorizationCompleted = corporationDetail?.limitValue?.vectorTicketDataStatus === Constant.VECTOR_DATA_STATUS.DONE
        // console.log('usingChatAI && AIVectorizationCompleted && isNotSearchChat :>> ', usingChatAI, AIVectorizationCompleted , isNotSearchChat);
        return (usingChatAI && AIVectorizationCompleted && isNotSearchChat);
    }

    useEffect(() => {
        let isReloadData = false;
        if (!Utils.isEmptyObject(viewSelected)) {
            let viewSelectedStructure = Utils.convertJSONDataToObject(viewSelected.structure);
            let viewSelectedOptions = viewSelectedStructure.options;
            isReloadData = corporationDetail.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON && viewSelectedOptions.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
            if (isReloadData) {
                setViewStructure(viewSelectedStructure);
            }
        }
        if (corporationDetail.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.OFF && isCheckMethodSimilar(viewStructure)) {
            isReloadData = true;
            let newViewStructure = cloneDeep(viewStructure);
            newViewStructure.options['sort'] = optionsSort !== Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR ? optionsSort : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
            newViewStructure.options.method = Constant.SETTING_SEARCH_KEYWORD.AND;
            setViewStructure(newViewStructure);
        }
        if (isReloadData) {
            setTriggerSearch(Date.now().toString());
        }

    }, [corporationDetail.limitValue?.usingChatAI]);

    const [openingTabChatAi, setOpeningTabChatAi] = useState('');

    // uef open tab ChatAI
    useEffect(() => {
        if (Utils.isEmptyString(openingTabChatAi) || Utils.isEmptyArray(panelList)) return;

        const panelOpenChatAi = panelList.find(p => p.type === Constant.PANEL_TYPE.OPEN_CHAT_AI);
        console.log('--- panelOpenChatAi', panelOpenChatAi)
        
        if (!panelOpenChatAi?.isDisplay) return;

        const listTabChatAi = panelOpenChatAi.tabList;
        const isOpened = listTabChatAi.find(t => t.id === openingTabChatAi);

        let createTimeout;
        if (isOpened) {
            createTimeout = setTimeout(() => {
                setOpeningTabChatAi('');
                hideLoadingMouse();
            }, 3000);
        }

        return () => {
            if (createTimeout) {
                clearTimeout(createTimeout);
            }
        }

    }, [openingTabChatAi, panelList])

    const onClickOpenChatAIPanel = async () => {
        showLoadingMouse();
        if (!Utils.isEmptyString(openingTabChatAi)) return;

        const propsClone = cloneDeep(props);
       
        let currentPanelId = propsClone.panelId;
        delete propsClone.setPanelList;
        delete propsClone.setSettingSlide;
        delete propsClone.setSettingSlideRecoilState;
        delete propsClone.setPanelListRecoilState
        delete propsClone.panelListRecoilState;
        delete propsClone.onStateChange;
        delete propsClone.history;
        delete propsClone.computedMatch;
        delete propsClone.corporationDetail;
        delete propsClone.projectDetail;
        delete propsClone.userDetail;

        console.log('--- onClickOpenChatAIPanel', propsClone)

        let projectIdKnowledgeSelected = organizationProject.value;
        if (organizationProject.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
            projectIdKnowledgeSelected = projectInuseDetail.id;
        }

        const viewStructureClone = cloneDeep(viewStructure);
        viewStructureClone.visibility = viewStructureClone.visibility
            ? viewStructureClone.visibility
            : visibilityKnowledgeAtom;

        const newThreadId = `ai_chat_thread_${uuidv4()}`;
        const filterKnowledgeListData = {
            viewStructure: viewStructureClone,
            projectSelectedId: projectIdKnowledgeSelected,
            resetSearchCondition: false,
            usingBasicPrompt: true,
            isInvalidPrecondition: false,
            threadId: newThreadId,
            chatThreadId: newThreadId,
            viewSelected: viewSelected,
            viewSelectedId: viewSelected?.id,
            projectIdKnowledgeSelected: projectIdKnowledgeSelected,
            isShowVisibilityKnowledgeAtom: isShowVisibilityKnowledgeAtom,
            visibilityKnowledgeAtom: visibilityKnowledgeAtom,
            hitNumber: totalTickets,
            ticketCreatedProjectId: destinationPrjId,
            ticketCreatedCorporationId: corporationSelectedId,
        }
        const chatThreadDto = {
            id: newThreadId,
            chatThreadId: newThreadId,
            corporationId: corporationDetail.id,
            affiliationProject: projectIdKnowledgeSelected,
            clientUUId: `client_uuid_${uuidv4()}`,
            creatorId: userDetail.id,
            metaData: { filterKnowledgeListData: JSON.stringify(filterKnowledgeListData) }
        }
        let tabId = `${Constant.TAB_PANEL_TYPE.NEW_TAB_CHAT_AI}_${Date.now().toString()}`;

        const newThreadChat = await createNewAIChatThread(chatThreadDto);
        if(!Utils.isEmptyObject(newThreadChat)) {
            addNewPanel({
                type: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                tabId: tabId,
                filterKnowledgeListData: filterKnowledgeListData,
                chatThreadId: newThreadId,
                currentPanelId: currentPanelId,
                props: {
                    ...propsClone,
                    
                    projectSelectedId: projectIdKnowledgeSelected,
                    visibilitySettingType: visibilityKnowledgeAtom,
                }
            });
            setOpeningTabChatAi(tabId);
        }

    }

    const isShowIconPageUnit = (ticketKnowledge, file) => {
        if (
            [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                ticketKnowledge.ticketType
            ) &&
            !file?.idTicketFileKnowledge
        )
            return false;
        const displayTextInFile = displayTagOfThumbAttach(
            ticketKnowledge,
            file.fileName
        );

        const isDisplayPdf = displayTextInFile.name === 'pdf';
        return isDisplayPdf &&
            file.splitPdf && 
            !file.isCreatingPageKnowledge &&
            viewStructure?.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM &&
            ticketKnowledge?.ticketType !==
                Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE && checkIsEnablePdfFunction()
    }

    const isShowAddNewView = () => {
        if (
            [
                Constant.TICKET_PROPERTY.DRAFT,
                Constant.TICKET_PROPERTY.DELETE,
                Constant.TICKET_PROPERTY.SYNONYM
            ].includes(viewStructure?.ticketProperty)
        )
            return false;

        return true;
    };

    const isDisplayIconCloseDestinationPrj = () => {
        const ticketProperty = viewStructure?.ticketProperty || Constant.TICKET_PROPERTY.SENT;
        return ![
            Constant.TICKET_PROPERTY.DRAFT,
            Constant.TICKET_PROPERTY.DELETE,
            Constant.TICKET_PROPERTY.SYNONYM
        ].includes(ticketProperty)
    }

    const isDisplayDestinationPrjBreadCrumb = () => {
        return (
            !Utils.isEmptyObject(organizationProject) &&
            !Utils.isEmptyString(destinationPrjId)
        )
    }

    const getDestinationPrjName = (prjId) => {
        if (Utils.isEmptyString(prjId)) return '';

        if (prjId === projectInuseDetail.id) {
            return I18n.get('CM-LABEL-PRJ-IN-USE');
        }
        let listProject = [
            ...organizationProject?.internalProjectList,
            ...organizationProject?.externalProjectList
        ];
        
        const selectedPrj = listProject.find(prj => prj.id === prjId);
        if (selectedPrj) return selectedPrj.label;

        return '';
    }

    const renderContentTab = () => {
        return (
            <div className="content-tab-body">
                <div className="searchFrame">
                    <div className="searchFrame-wrap">
                        <div className="searchFrame-actions">
                            <Select
                                disabled={
                                    viewStructure.options.method ==
                                    Constant.SETTING_SEARCH_KEYWORD.SIMILAR
                                }
                                className="search-options-select"
                                variant="outlined"
                                defaultValue={Constant.SETTING_SEARCH_KEYWORD.MUTIPLE}
                                value={
                                    viewStructure.options.attribute
                                        ? viewStructure.options.attribute
                                        : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE
                                }
                                onChange={e => handleChangeSearchAttribute(e, argsCommon)}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null,
                                    className: 'selectDrop'
                                }}
                            >
                                <MenuItem value={Constant.SETTING_SEARCH_KEYWORD.MUTIPLE}>
                                    {I18n.get('DRILLB012')}
                                </MenuItem>
                                <MenuItem value={Constant.SETTING_SEARCH_KEYWORD.COMMENT}>
                                    {I18n.get('DRILLB013')}
                                </MenuItem>
                            </Select>
                            <Paper className={classes.root}>
                                <Autocomplete
                                    PopperComponent={({ style, ...props }) => (
                                        <Popper
                                            {...props}
                                            style={{ ...style }} // width is passed in 'style' prop
                                            className="selectDrop"
                                        />
                                    )}
                                    className="search-keyword"
                                    freeSolo
                                    disablePortal
                                    sx={{
                                        maxHeight: 10
                                    }}
                                    options={keywordSearch ? sugguestionList : []}
                                    getOptionLabel={option => {
                                        return option.label || '';
                                    }}
                                    filterOptions={(options, state) => {
                                        const keyword = normalizeString(state.inputValue);
                                        return options.filter((option) =>
                                            normalizeString(option.labelForSearch).includes(keyword)
                                        );
                                    }}
                                
                                    renderOption={option => (
                                        <Tooltip title={option.label}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                {option.label}
                                            </span>
                                        </Tooltip>
                                    )}
                                    onChange={(e, value) =>
                                        onSelectSugguestOption(e, value, argsCommon)
                                    }
                                    inputValue={keywordSearch}
                                    renderInput={params => (
                                        <>
                                            <TextField
                                                {...params}
                                                // className={classes.input}
                                                defaultValue={viewStructure.keyword}
                                                placeholder="キーワードを入力してください"
                                                value={keywordSearch}
                                                onKeyPress={e =>
                                                    onKeyPressSearchKeyWord(e, argsCommon)
                                                }
                                                onChange={e => setKeywordSearch(e.target.value)}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter') {
                                                        e.stopPropagation();
                                                    }
                                                }}
                                                inputRef={inputKeyWordRef}
                                                variant="outlined"
                                            />
                                        </>
                                    )}
                                />
                                <Button
                                    className="btn-icon-search"
                                    variant="contained"
                                    color="primary"
                                    onClick={e => onSubmitSearchListKnowledge(argsCommon)}
                                >
                                    <img src="/assets/image/icon-searchFrame.svg" alt="" />
                                </Button>
                            </Paper>
                        </div>
                        <Button
                            className="btn-tag-search btn-light btn-hg32"
                            variant="outlined"
                            onClick={e => openDrilldownAndDetailSearch(argsCommon)}
                        >
                            <span className="itemSearch">
                                <img src="/assets/image/icon-btnSearch.svg" alt="" />
                            </span>
                            {I18n.get('CM-BUTTON-OPEN-DRILLDOWN')}
                        </Button>
                        {isDisplayIconChatAI && (
                            <Tooltip
                                placement="bottom-start"
                                arrow={true}
                                title={I18n.get(
                                    'MSG-AI-TOOLTIP-WHEN-OPEN-AI-ON-KNOLEDGE-LIST-PANEL'
                                )}
                            >
                                <img
                                    src="/assets/image/icon-chat-ai.svg"
                                    alt="chat-ai-icon"
                                    className="chat-ai-btn"
                                    onClick={async () => await onClickOpenChatAIPanel()}
                                />
                            </Tooltip>
                        )}
                    </div>
                </div>

                <div className="search-options-group">
                    <div className="search-option-method-attribute content-padding">
                        <RadioGroup
                            id="radio-buttons-group-search-method"
                            key={`row-radio-buttons-group-search-method`}
                            row
                            aria-labelledby="radio-buttons-group-label-method"
                            name="row-radio-buttons-group-search-method"
                            value={
                                viewStructure.options.method
                                    ? viewStructure.options.method
                                    : Constant.SETTING_SEARCH_KEYWORD.AND
                            }
                            onChange={e => handleChangeSearchMethod(e, argsCommon)}
                        >
                            <div className="searchOption-radio">
                                <FormControlLabel
                                    className="custom-radio search-item"
                                    value={Constant.SETTING_SEARCH_KEYWORD.AND}
                                    control={<Radio size="small" />}
                                    label={I18n.get('DRILLB010')}
                                />
                                <FormControlLabel
                                    className="custom-radio search-item"
                                    value={Constant.SETTING_SEARCH_KEYWORD.OR}
                                    control={<Radio size="small" />}
                                    label={I18n.get('DRILLB011')}
                                />
                                {isShowOptionSearchSimilar() && (
                                    <FormControlLabel
                                        className="custom-radio search-item"
                                        value={Constant.SETTING_SEARCH_KEYWORD.SIMILAR}
                                        control={<Radio size="small" />}
                                        label={I18n.get('OPTION-SEARCH-SIMILAR')}
                                        disabled={isDisableSimilarSearch}
                                    />
                                )}
                            </div>
                        </RadioGroup>
                    </div>

                    {isDisplayIconSearchFileAndPageKnowledge(
                        corporationDetail,
                        viewStructure,
                        Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
                    ) && (
                        <Tooltip
                            arrow={true}
                            title={I18n.get('MSG-SEARCH-INCLUDES-PDF-OF-KNOWLEDGE')}
                        >
                            <div className="checkbox-search-includes-page-pdf">
                                <div className="search-item">
                                    <input
                                        type="checkbox"
                                        id={`checkbox-include-attach-pdf`}
                                        defaultChecked={isIncludeAttachPdf}
                                        checked={isIncludeAttachPdf}
                                        className="search-include-attach-pdf"
                                        onClick={e => {
                                            setIsIncludeAttachPdf(e.target.checked);
                                            handleChangeSearchPdfOption(
                                                e.target.checked,
                                                'isIncludeAttachPdf',
                                                {
                                                    viewStructure,
                                                    setViewStructure
                                                }
                                            );
                                        }}
                                        disabled={isDisableIncludeAttachPdf}
                                    />
                                    <label
                                        className={`label-search-pdf ${
                                            isDisableIncludeAttachPdf
                                                ? 'search-synonym-disable'
                                                : 'search-synonym-enable'
                                        }`}
                                        htmlFor={`checkbox-include-attach-pdf`}
                                    >
                                        {I18n.get('LABEL_INCLUDE_ATTACH_PDF')}
                                    </label>
                                </div>
                            </div>
                        </Tooltip>
                    )}

                    {isDisplayOptionSearchSynonymForKnowledgeList(
                        corporationDetail,
                        projectInuseDetail,
                        organizationProject,
                        viewStructure
                    ) && (
                        <Tooltip
                            arrow={true}
                            title={
                                organizationProject.value ===
                                Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
                                    ? I18n.get('MSG-CM-USE-CURRENT-SYNONYM-KNOW-TO-SEARCH')
                                    : I18n.get('MSG-CM-USE-SYNONYM-KNOW-TO-SEARCH')
                            }
                        >
                            <div className="search-synonym-option search-item">
                                <input
                                    type="checkbox"
                                    id={`checkbox-include-search-synonym`}
                                    defaultChecked={isSearchSynonym}
                                    checked={isSearchSynonym}
                                    className="search-synonym-checkbox"
                                    onClick={e => {
                                        setIsSearchSynonym(e.target.checked);
                                        handleOnChangeSearchSynonym(
                                            e.target.checked,
                                            'isSearchSynonym',
                                            {
                                                viewStructure,
                                                setViewStructure,
                                                ...argsCommon
                                            }
                                        );
                                    }}
                                    disabled={isDisableSynonymSearch}
                                />
                                <label
                                    className={`label-search-synonym ${
                                        isDisableSynonymSearch
                                            ? 'search-synonym-disable'
                                            : 'search-synonym-enable'
                                    }`}
                                    htmlFor={`checkbox-include-search-synonym`}
                                >
                                    類義語展開する
                                </label>
                            </div>
                        </Tooltip>
                    )}
                </div>

                {isShowIconBreadCrumb() && (
                    <div className="searchCondition searchCondition-page-knowledge">
                        <div className="searchCondition-item" key="breadcrumb">
                            <span className="close-icon">
                                <CloseIcon
                                    fontSize="inherit"
                                    onClick={() => closeIconBreadCrumb()}
                                />
                            </span>
                            <span className="option-name">
                                {I18n.get('LABEL-PAGE-KNOWLEDGE-UNIT')}
                                {fileNamePdfSelect ? `(${fileNamePdfSelect})` : ''}
                            </span>
                        </div>
                    </div>
                )}

                <div className="searchCondition">
                    {!Utils.isEmptyArray(drilldownDataSelected) &&
                        drilldownDataSelected
                            ?.filter(item => {
                                
                                // filter bookmark of other project
                                if(item.id === Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK){
                                    let sharedBookmarkOfView = viewStructure.sharedBookmark;
                                    if(!Utils.isEmptyArray(sharedBookmarkOfView)){
                                        const bookmarkItem = sharedBookmarkOfView?.find(bookmark => bookmark.bookmarkId === item.itemId);
                                        if(!Utils.isEmptyObject(bookmarkItem) && bookmarkItem.projectSelectId !== projectInuseDetail.id ){
                                            return false
                                        }
                                    }
                                };

                                // filter private bookmark
                                if(item.id === Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK){
                                    let privateBookmarkOfView = viewStructure.privateBookmark;
                                    if(!Utils.isEmptyArray(privateBookmarkOfView)){
                                        const bookmarkItem = privateBookmarkOfView?.find(bookmark => bookmark.bookmarkId === item.itemId);
                                        if (
                                            !Utils.isEmptyObject(bookmarkItem) &&
                                            (bookmarkItem.projectSelectId !==
                                                projectInuseDetail.id ||
                                                bookmarkItem.userSelectId !== userDetail.id)
                                        ) {
                                            return false;
                                        }
                                    }
                                };
                                if (item.isPdfSystemFile && !checkIsEnablePdfFunction()) {
                                    return false;
                                }
                                return true;
                            })
                            ?.map(item => {
                                return (
                                    <div
                                        className="searchCondition-item"
                                        key={`${item.id}${item.itemLabel}`}
                                    >
                                        <span className="close-icon">
                                            {item.fieldLabel !==
                                                I18n.get('CM-DROPDOWN-PRJ-CREATE-KNOWLEDGE') && (
                                                <CloseIcon
                                                    fontSize="inherit"
                                                    onClick={e =>
                                                        removeDrillDownSelected(
                                                            item,
                                                            argsCommon,
                                                            setIsShowEditTagField
                                                        )
                                                    }
                                                />
                                            )}
                                        </span>
                                        <Tooltip
                                            title={item.itemLabel}
                                            arrow={false}
                                            placement="top-start"
                                        >
                                            <span className="itemTagFieldLabel">
                                                {item.itemLabel}
                                            </span>
                                        </Tooltip>
                                        <span className="option-name">←</span>
                                        <span className="option-name">{item.fieldLabel}</span>
                                    </div>
                                );
                            })}
                    
                    {isDisplayDestinationPrjBreadCrumb() && (
                        <div className="searchCondition-item" key="destinationPrjBreadcrumb">
                            <span className="close-icon">
                                {isDisplayIconCloseDestinationPrj() && (
                                    <CloseIcon
                                        fontSize="inherit" 
                                        onClick={e => {
                                            setIsShowEditRangeMulti(false)
                                            setIsShowEditTagField(false)

                                            removeDrillDownSelected(
                                                {
                                                    id:
                                                        Constant.FORMAT_OPTION_SEARCH
                                                            .TICKET_CREATED_PROJECT_ID,
                                                    value: destinationPrjId,
                                                    itemLabel: getDestinationPrjName(
                                                        destinationPrjId
                                                    ),
                                                    fieldLabel: I18n.get(
                                                        'CM-DROPDOWN-PRJ-CREATE-KNOWLEDGE'
                                                    )
                                                },
                                                argsCommon,
                                                setIsShowEditTagField
                                            );
                                        }}
                                    />
                                )}
                            </span>
                            <span className="option-name">
                                {getDestinationPrjName(destinationPrjId)}←
                                {I18n.get('CM-DROPDOWN-PRJ-CREATE-KNOWLEDGE')}
                            </span>
                        </div>
                    )}

                    {optionSearchTimeRange && (
                        <div className="searchCondition-item" key="optionSearchTimeRange">
                            <span className="close-icon">
                                <CloseIcon
                                    fontSize="inherit"
                                    onClick={e =>
                                        removeDrillDownSelectedSearchTimeRange(argsCommon)
                                    }
                                />
                            </span>
                            <span>{optionSearchTimeRange}</span>
                        </div>
                    )}

                    {optionSearchTimeAgo && (
                        <div className="searchCondition-item" key="optionSearchTimeAgo">
                            <span className="close-icon">
                                <CloseIcon
                                    fontSize="inherit"
                                    onClick={e => removeDrillDownSelectedSearchTimeAgo(argsCommon)}
                                />
                            </span>
                            <span>{optionSearchTimeAgo}</span>
                        </div>
                    )}
                </div>

                {/* BulkAction */}
                <BulkAction
                    listTicketKnowledge={ticketKnowledgeList}
                    totalTickets={totalTickets}
                    viewSelected={viewSelected}
                    selectedProject={organizationProject.value}
                    onSubmitSearchListKnowledge={() => onSubmitSearchListKnowledge(argsCommon)}
                    currentSearchParams={currentSearchParams}
                    // isHasEditPermissionEveryTicket={isHasEditPermissionEveryTicket}
                    isHasEditPermissionSomeTicket={isHasEditPermissionSomeTicket}
                    viewStructure={viewStructure}
                    drillDownData={drillDownData}
                    isProjectManager={isProjectManager}
                    projectInuseDetail={projectInuseDetail}
                    setIsShowEditRangeMulti={setIsShowEditRangeMulti}
                    setIsShowEditTagField={setIsShowEditTagField}
                    setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                    msgInProcessingIcon={msgInProcessingIcon}
                    setMsgInProcessingIcon={setMsgInProcessingIcon}
                    setLimitNotiMessage={setLimitNotiMessage}
                    corporationDetail={corporationDetail}
                    selectedFilterForm={selectedFilterForm}
                    setSelectedFilterForm={setSelectedFilterForm}
                    setIsShowExportMenu={setIsShowExportMenu}
                    isOpenDialogConfirm = {isOpenDialogConfirm}
                    setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                    formIdSearchConditionFilterBy={formIdSearchConditionFilterBy}
                />

                {isShowFormEditRangeMulti(
                    projectList,
                    destinationPrjId,
                    totalTickets, 
                    isShowEditRangeMulti, 
                    organizationProject.value)  && (
                    <RenderMultiPublicRange 
                        listAdditionalAllRole={listAdditionalAllRole}
                        currentSearchParams={currentSearchParams}
                        listDataPublicRange={listDataPublicRange}
                        totalTickets={totalTickets}
                        setIsShowEditRangeMulti={setIsShowEditRangeMulti}
                        setListAdditionalAllRole={setListAdditionalAllRole}
                        setListDataPublicRange={setListDataPublicRange}
                        isLoadDataForPublicRangeDone={isLoadDataForPublicRangeDone}
                        setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                        msgInProcessingIcon={msgInProcessingIcon}
                        setMsgInProcessingIcon={setMsgInProcessingIcon}
                        drilldownDataSelected={drilldownDataSelected}
                    />
                )}
                {isShowEditTagFields && (
                    <RenderTagFieldInForm
                        setIsShowEditTagField={setIsShowEditTagField}
                        listTagFieldOfForm={listTagFieldOfForm}
                        drillDownData={drillDownData}
                        totalTickets={totalTickets}
                        currentSearchParams={currentSearchParams}
                        setIsShowDialogReload = {setIsShowDialogReload}
                        setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                        msgInProcessingIcon={msgInProcessingIcon}
                        setMsgInProcessingIcon={setMsgInProcessingIcon}
                        loadingBulkItemListTagField={loadingBulkItemListTagField}
                        action={Constant.BULK_ACTION.EDIT_TAG_FIELD}
                        selectedFormId={{selectedFormId}}
                    />
                )}
                {isShowExportMenu && (
                    <RenderExportMenu
                        action={Constant.BULK_ACTION.EXPORT_CSV}
                        setIsShowExportMenu={setIsShowExportMenu}
                        setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                        currentSearchParams={currentSearchParams}
                    />
                )}
                <ConfirmDialog
                    isOpen={isShowDialogReload}
                    msgConfirm={I18n.get('COMMSG030')}
                    okCallBack={() => window.location.reload()}
                />
                {/* render ticket knowledge list */}
                <div className="list-ticket-knowledge" onScroll={e => handleOnScroll(e)}>
                    {!Utils.isEmptyArray(ticketKnowledgeList) &&
                        ticketKnowledgeList.map((ticketKnowledge, index) => {
                            return renderTicketKnowledgeItem(ticketKnowledge);
                        })}
                    {!isLoading && Utils.isEmptyArray(ticketKnowledgeList) && (
                        <div className="listEmpty listEmpty-qa">
                            <span className="listEmpty-item">
                                <img src="/assets/image/icon-listEmpty.svg" alt="" />
                            </span>
                            {I18n.get('COMMSG001')}
                        </div>
                    )}
                </div>
            </div>
        );
    };


    const renderListView = () => {
        let listViewShow = listView.filter(x => {
            const structure = Utils.convertJSONDataToObject(x.structure);
            if (structure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
                const limitValue = corporationDetail.limitValue;
                let synonymSearch = limitValue?.synonymSearch;

                const projectSetting = Utils.convertJSONDataToObject(
                    projectInuseDetail?.projectSetting
                );
                
                if(corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK) {
                    let inviterSetting = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting);
                    synonymSearch = inviterSetting.synonymSearch;

                }

                return (
                    x.status === Constant.STATUS_VIEW.SHOW &&
                    synonymSearch === Constant.STATUS_SERVICE_PERMISSION.ON &&
                    projectSetting?.usingSynonym
                );
            }
            return x.status === Constant.STATUS_VIEW.SHOW;
        });
        let isDisplayNavTabs = listViewShow.length <= Constant.LIST_VIEW_TICKET_HELP_DESK;
        let listViewOption = listView;

        if (
            !Utils.isEmptyObject(organizationProject) &&
            organizationProject.value !== Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
        ) {

            const curentProjectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
            if(!Utils.isEmptyObject(curentProjectSetting)) {
                let usingSynonym = curentProjectSetting?.usingSynonym;
                let limitValue = corporationDetail.limitValue;
                let synonymSearch = limitValue?.synonymSearch;
                if(corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK) {
                    let inviterSetting = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting);
                    synonymSearch = inviterSetting.synonymSearch;
                }
                if (synonymSearch != Constant.STATUS_SERVICE_PERMISSION.ON || !usingSynonym) {
                    listViewOption = listView.filter(view => {
                        let structure = Utils.convertJSONDataToObject(view.structure);
                        return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM;
                    });
                }
            }

            return (
                <div className="navTabs navTabs-flex">
                    <div className="navTabs-group">
                        <DialogViewNameError 
                            setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                            inputViewNameRef={inputViewNameRef}
                            isOpenDialogViewNameError={isOpenDialogViewNameError}
                            viewNameErrorType={viewNameErrorType}
                        />
                        <DialogNoticeViewChanged {...argsCommon} setIsScrollNewViews={setIsScrollNewViews}/>

                        <DraggableViewsList
                            tabs={listViewShow}
                            viewSelected={viewSelected}
                            isViewFromKnowledgePanel={organizationProject.value}
                            setFileNamePdfSelect={setFileNamePdfSelect}
                            {...argsCommon}
                        />
                    </div>
                    <div className="btnTabs-wrap">
                        {!isDisplayNavTabs && <SeemoreViewKnowledgeList {...argsCommon} listViewShow={listViewShow} /> }
                        {/* <Button onClick={async () => await createNewTask()}>create</Button>
                        <Button onClick={async () => await updateTaskById()}>update</Button> */}
                        { checkDisplayBtnAddView( isCustomer, userRoleInProject, viewStructure, organizationProject, setIsCustomer) && (
                            <div className="btnAdd-viewTabs">
                                <IconButton
                                    className="btnAdd-views"
                                    onClick={event => setAddViewPopover(event.currentTarget)}
                                >
                                    <img src="/assets/image/icon-add-plus.svg" alt=""/>
                                </IconButton>

                                <Popover
                                    className="viewList-action"
                                    id={id}
                                    open={isOpenFormTypePopover}
                                    anchorEl={addViewPopover}
                                    onClose={e => setAddViewPopover(null)}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center'}}
                                    transformOrigin={{ vertical: 'top', horizontal: 'center'}}
                                >
                                    <div className="add-view-more">
                                        <List>
                                            {
                                                isShowAddNewView() &&
                                                (
                                                    <ListItem disablePadding onClick={onClickAddNewView}>
                                                        <ListItemText primary="新規追加" />
                                                    </ListItem>
                                                )
                                                 
                                            }

                                            <ListItem disablePadding onClick={handleClickOpenListViewHide} >
                                                <ListItemText primary="非表示ビュー一覧" />
                                                {openListViewHide ? <ExpandLess /> : <ExpandMore />}
                                            </ListItem>
                                            <Collapse in={openListViewHide} timeout="auto" unmountOnExit>
                                                <List className="listView-hide">
                                                    {!Utils.isEmptyArray(listViewOption) &&
                                                        listViewOption.map(view => {
                                                            let viewNameObj = JSON.parse(view.name);
                                                            let viewName = viewNameObj['jp'].text;
                                                            return (
                                                                view.status === Constant.STATUS_VIEW.HIDDEN && (
                                                                    <ListItem key={view.id} onClick={() => onHandlerShowView( view, argsCommon)}>
                                                                        <Tooltip title={viewName} placement="right" arrow interactive >
                                                                            <ListItemText primary={viewName} />
                                                                        </Tooltip>
                                                                    </ListItem>
                                                                )
                                                            );
                                                        })}
                                                </List>
                                            </Collapse>
                                        </List>
                                    </div>
                                </Popover>
                            </div>
                        )}

                        { permissionCreateTicketKnowledge( organizationProject, userPermissionView ) && (
                            <>
                                <Tooltip title="新規作成">
                                    <button
                                        className="btn-add-ticket"
                                        onClick={() => handleClickCreateTicketType( Constant.TICKET_TYPE.KNOWLEDGE, argsCommon, props, isCustomer)}
                                    >
                                        <img src="/assets/image/icon-add-ticket.svg" alt="icon-add-ticket" />
                                        <span className="text-add-ticket">作成</span>
                                    </button>
                                </Tooltip>
                            </>
                        )}
                    </div>
                </div>
            );
        }
    };

    const onChangeSelectedOption = async (selectedValue) => {
        let orgData = {...organizationProject};
        // let selectedValue = e.target.value; //project
        orgData.value = selectedValue;

        let selectedPrjId = selectedValue;
        
        if (selectedValue === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
            orgData.corpId = corporationDetail.id;
            orgData.label = I18n.get('CM-LABEL-PRJ-IN-USE');
            selectedPrjId = projectInuseDetail.id;
            
            setVisibilityKnowledgeAtom(Constant.VISIBILITY_SETTING_TYPE.PRIVATE);
            setIsShowVisibilityKnowledgeAtom(true);
            setProjectSelectedId(selectedPrjId);
            setOrganizationProject(orgData);
            setCorporationSelectedId(orgData.corpId);
            setIsCustomer(false);
            
            // reset view
            setViewStructure(prev => ({
                ...prev,
                visibility: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
                ticketCreatedProjectId: selectedPrjId
            }));

            setViewKnowledgeProjectSelected(prev => ({
                ...prev,
                projectId: projectInuseDetail.id
            }));
            setDestinationPrjId(selectedPrjId);

        }
        if (selectedValue === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
            orgData.corpId = corporationDetail.id;
            let visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
            if (orgData.corpId === corporationDetail.id && userPermissionView.type === Constant.USER_PERMISSION_VIEW_KNOWLEDGE.B2C) {
                visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
            }

            orgData.label = I18n.get('CM-LABEL-ALL-KNOWLEDGE-IN-ORG');
            setIsShowVisibilityKnowledgeAtom(false);
            setVisibilityKnowledgeAtom(visibility);
            setProjectSelectedId(selectedPrjId);
            setCorporationSelectedId(orgData.corpId);
            setOrganizationProject(orgData);
            // reset view
            setViewStructure(prev => ({
                ...prev,
                options : {
                    sort: Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT
                },
                visibility: visibility,
                ticketCreatedProjectId: ''
            }));

            setViewKnowledgeProjectSelected(prev => ({
                ...prev,
                projectId: Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
            }));

            setDestinationPrjId('');
        }
        if (
            ![
                Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE,
                Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
            ].includes(selectedValue)
        ) {
            let listProject = [
                ...organizationProject?.internalProjectList,
                ...organizationProject?.externalProjectList
            ];
            const foundProject = listProject.find(prj => prj.value === selectedValue);
            if (!Utils.isEmptyObject(foundProject)) {
                orgData.label = foundProject.label;
                orgData.prjId = foundProject.id;
                orgData.corpId = foundProject.corpId;

                let visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
                if (foundProject.corpId !== corporationDetail.id || (foundProject.corpId === corporationDetail.id && userPermissionView.type === Constant.USER_PERMISSION_VIEW_KNOWLEDGE.B2C)) {
                    visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
                }
                setIsShowVisibilityKnowledgeAtom(false)
                setVisibilityKnowledgeAtom(visibility);

                setProjectSelectedId(foundProject.id);
                setViewKnowledgeProjectSelected({
                    projectId: foundProject.id,
                    corporationId: foundProject.corpId,
                    inviter: foundProject?.inviter
                });

                setCorporationSelectedId(foundProject.corpId);
                setOrganizationProject(orgData);

                setViewStructure(prev => ({
                    ...prev,
                    visibility: visibility,
                    ticketCreatedProjectId: foundProject.id
                }));
                setDestinationPrjId(foundProject.id);
            }
        }

        setFileNamePdfSelect('')
        // updatePanelDrilldown(orgData);
        // setTriggerSearch(Date.now().toString());
    };

    const renderSelectOptionByUserPermissionView = () => {
        return (
            <>
                {!Utils.isEmptyObject(organizationProject) ? (
                    <TextField
                        className="select-org-field"
                        value={organizationProject.value}
                        select
                        onChange={event =>  onChangeSelectedOption(event.target.value)}
                        InputProps={{
                            className: 'field-inout'
                        }}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                    >
                        {[
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER
                        ].includes(userPermissionView.type) && (
                            userPermissionView.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON
                        ) && (
                            <MenuItem value={Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE}>
                                <OverFlowTooltipWithTabsMui
                                    className="prj-in-use"
                                    value={I18n.get('CM-LABEL-PRJ-IN-USE')}
                                />
                            </MenuItem>
                        )}

                        {[
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT
                        ].includes(userPermissionView.type) && (
                            userPermissionView.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON
                        ) && (
                            <MenuItem value={Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG}>
                                <OverFlowTooltipWithTabsMui
                                    className="all-knowledge-in-org"
                                    value={I18n.get('CM-LABEL-ALL-KNOWLEDGE-IN-ORG')}
                                />
                            </MenuItem>
                        )}

                        {!Utils.isEmptyArray(organizationProject.internalProjectList) && (
                            userPermissionView.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON
                        ) && (
                            <MenuItem disabled>
                                <OverFlowTooltipWithTabsMui
                                    className="internal-prj"
                                    value={I18n.get('CM-LABEL-INTERNAL-PRJ')}
                                />
                            </MenuItem>
                        )}
                        {!Utils.isEmptyArray(organizationProject.internalProjectList) &&
                            organizationProject.internalProjectList.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    <OverFlowTooltipWithTabsMui
                                        className="prj-select-option"
                                        value={option.label}
                                    />
                                </MenuItem>
                            ))}

                        {[
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_SUPPORTED
                        ].includes(
                            userPermissionView.type
                        ) &&
                            !Utils.isEmptyArray(organizationProject.externalProjectList) && (
                                <MenuItem disabled>
                                    <OverFlowTooltipWithTabsMui
                                        className="external-prj"
                                        value={I18n.get('CM-LABEL-EXTERNAL-PRJ')}
                                    />
                                </MenuItem>
                            )}
                        {!Utils.isEmptyArray(organizationProject.externalProjectList) &&
                            organizationProject.externalProjectList.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    <OverFlowTooltipWithTabsMui
                                        className="prj-select-option"
                                        value={option.label}
                                    />
                                </MenuItem>
                            ))}
                    </TextField>
                ) : (
                    <></>
                )}
            </>
        );
    };

    return (
        <div className="mainWrap">
            <LoadingPanel isLoading={isLoading || isLoadingView || isIsnitData} />
            {!Utils.isEmptyObject(organizationProject) && (
                <>
                    <div className="customMainTopKnowledge">
                        <div className="navSelect">
                            <div className="navSelect-org">
                                {renderSelectOptionByUserPermissionView()}
                            </div>
                        </div>
                        {renderListView()}
                    </div>
                    <div className="contentTab">{renderContentTab()}</div>
                </>
            )}
            <AlertDialog isOpen={isOpenAlertDialog} setIsOpen={setIsOpenAlertDialog} />
            <DataChangePleaseReloadModal
                {...argsCommon}
                content={contentModalReloadPage}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isShowDialogNotiLimit}
                msgConfirm={limitNotiMessage ? limitNotiMessage : I18n.get('MSG-CM-EXCEED-MAX-CONTENT-BULK-ACTION')}
                okCallBack={() => {
                    setIsShowDialogNotiLimit(false);
                    setLimitNotiMessage('');
                }}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={<div><span>{I18n.get('MSG-CM-EXPIRED-SESSION-1')}</span><br/><span>{I18n.get('MSG-CM-EXPIRED-SESSION-2')}</span></div>}
                textSubmit={I18n.get('COMBTN004')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />
        </div>
    );
}